import { PathUtils } from "@adobe/aem-spa-page-model-manager";
import window from "global";
import i18next, { t } from "i18next";
import Cookies from "js-cookie";
import _, { cloneDeep, find, isEmpty } from "lodash";
import { OPTION_VALUES, PAYMENT_MONTHS, SALARY_RANGE, IWISH, IPS_RIDER } from "@ipru-common/constants/InputValues";
import { KYC_MISMATCH_TYPE } from "@ipru-common/constants/SavingsAppForm";
import { CurrentProduct } from "shared-library";
import { getDefaultSelectedFund } from "@common-components/constants/quote";
import i18n from "i18next";
import { getIpAddress } from "@ipru-common/services/service";
import * as yup from "yup";
import {
  BASE_PATH,
  CURRENCY_SIGN,
  HINDI_MONTHS_NAME,
  LANGUAGES,
  MONTHS,
  MONTHS_ABBR,
  MONTHS_SHORT_NAME,
  NRI_HELPDESK_END_TIME,
  NRI_HELPDESK_START_TIME,
  PERSONA_LIST,
  SITE_DOMAIN,
  FUND_NAMES,
  LMS_CONSTANTS,
  TRULY,
  FALSY,
  productCTName,
  PARTNER_LIST,
  LIGO_PRODUCTS,
  PENNY_DROP_ELIGIBLE_PRODUCTS,
  APP_KEY_BLOWFISH2,
  ELIGIBLE_APPOINTMENT_SCHEDULING_PRODUCTS,
  FUNDS_REQUIRED_PRODUCTS,
  PARTNER_DIRECT_REDIRECTION_ELIGIBLE_PRODUCTS,
  GPP_ANNUITY_OPTION_DA,
  API_CONSTANTS,
  FUND_RATES,
  ENGLISH,
  DOLLAR_SIGN,
  LANGUAGE_PARAM,
  MONEY_MARKET_FUND,
  GROUP_EMP_PRODUCTS,
} from "../constants/SiteConstants";
import history from "./history";
import { checkPersonaEmployeeQdata } from "./IPSLifeCoverPremiumCalculations";
import {
  PLAN_TYPES,
  EVENT_NAME,
  PRODUCT_CATEGORIES,
  PRODUCT_CODES,
  PRODUCT_DETAILS,
  PRODUCT_KEY,
  PRODUCT_KEYS,
  PRODUCT_NAMES,
  PRODUCT_SHORT_NAME,
  STAMP_ALLOWED_PRODUCTS,
  PRODUCT_TITLE,
  PRODUCTS_LOGO,
  PRODUCT_TYPES,
} from "@ipru-common/constants/products";

import { ProductFieldEligibility } from "@ipru-common/libs/SavingsAppForm/ProductFieldEligibility";
// import { ProductFieldEligibility } from "@ipru-common/libs/SavingsAppForm/ProductFieldEligibility";
import useBlowFish from "@ipru-common/hooks/useBlowFish";
import { useLocation } from "react-router";
import { getLeadPageInputs } from "./UserInputMapper/LeadPageInput";
import { useQData } from "@ipru-common/hooks/useQData";
import QuoteFormStore from "@ipru-common/store/QuoteFormStore";
import { RIDER_TYPES } from "@ipru-common/constants/SignatureUlipRider";
import { useAppFormContext } from "@ipru-common/context/AppFormContext";
import GlobalStore from "@ipru-common/store/GlobalStore";
import { checkCompanionDiscountIsApplicable } from "./QuoteCommonFunctions";
import FundsStore from "@ipru-common/store/FundsStore";
import { getAge } from "@ipru-common/libs/ValidationSchemas/CustomRules";

export function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function getLocalTime(date = new Date()) {
  const offset = -date.getTimezoneOffset();
  const sign = offset >= 0 ? "+" : "-";
  const hours = String(Math.floor(Math.abs(offset) / 60)).padStart(2, "0");
  const minutes = String(Math.abs(offset) % 60).padStart(2, "0");
  const localDate = new Date(date.getTime() + offset * 60000);
  return `${localDate.toISOString().slice(0, -1)}${sign}${hours}:${minutes}`;
}

export const compactNumberForm = (val, point) => {
  if (val >= 10000000) {
    val = (val / 10000000).toFixed(point);
    val = parseFloat(val) + " Crore";
  } else if (val >= 100000) {
    val = (val / 100000).toFixed(point);
    val = parseFloat(val) + " Lakh";
  } else {
    val = parseFloat(val).toFixed(0);
    val = (val + "").replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");
  }
  return val;
};

export function getFields(fields) {
  const initialValues = {};
  for (const key in fields) {
    if (Object.hasOwnProperty.call(fields, key)) {
      initialValues[key] = fields[key].value;
    }
  }
  return initialValues;
}

export const scrollToRightEnd = (containerRef) => {
  if (containerRef.current) {
    containerRef.current.scrollTo({
      left: containerRef.current.scrollWidth,
      behavior: "smooth",
    });
  }
};
export const scrollToLeftEnd = (containerRef) => {
  if (containerRef.current) {
    containerRef.current.scrollTo({
      left: 0,
      behavior: "smooth",
    });
  }
};

export const bulkUpdateValues = (data, setValue) =>
  Object.entries(data).forEach(([name, value]) => setValue(name, value));

export const allowOnlyNumbers = (e) => {
  // prevent shift
  if (e.shiftKey) {
    e.preventDefault();
  }
  if (
    // Allow: backspace, delete, tab, escape, enter, and .
    [46, 8, 9, 27, 13, 110, 190].includes(e.keyCode) ||
    // Allow: Ctrl+A
    (e.keyCode === 65 && (e.ctrlKey || e.metaKey)) ||
    // Allow: Ctrl+C
    (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) ||
    // Allow: Ctrl+X
    (e.keyCode === 88 && (e.ctrlKey || e.metaKey)) ||
    // Allow: home, end, left, right
    (e.keyCode >= 35 && e.keyCode <= 39)
  ) {
    // Let it happen, don't do anything
    return;
  }
  // Ensure that it is a number and stop the keypress
  if ((e.shiftKey || e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105)) {
    e.preventDefault();
  }
};

// this function prevents decimal point an accept only numbers 1 to 9
export const allowOnlyDigits = (e) => {
  // prevent shift
  if (e.shiftKey) {
    e.preventDefault();
  }
  if (
    // Allow: backspace, delete, tab, escape, enter, and .
    [46, 8, 9, 27, 13, 110].includes(e.keyCode) ||
    // Allow: Ctrl+A
    (e.keyCode === 65 && (e.ctrlKey || e.metaKey)) ||
    // Allow: Ctrl+C
    (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) ||
    // Allow: Ctrl+X
    (e.keyCode === 88 && (e.ctrlKey || e.metaKey)) ||
    // Allow: home, end, left, right
    (e.keyCode >= 35 && e.keyCode <= 39)
  ) {
    // Let it happen, don't do anything
    return;
  }
  // Ensure that it is a number and stop the keypress
  if ((e.shiftKey || e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105)) {
    e.preventDefault();
  }
};

export const allowOnlyDigitsNoLeadingZero = (e) => {
  // Prevent Shift key usage
  if (e.shiftKey) {
    e.preventDefault();
  }

  // Allow: backspace, delete, tab, escape, enter, and navigation keys
  if (
    [46, 8, 9, 27, 13].includes(e.keyCode) || // Backspace, delete, tab, escape, enter
    (e.keyCode >= 35 && e.keyCode <= 39) || // Home, end, left, right
    ([65, 67, 88].includes(e.keyCode) && (e.ctrlKey || e.metaKey)) // Ctrl+A, Ctrl+C, Ctrl+X
  ) {
    return; // Allow default behavior
  }

  // Get the current input value
  const input = e.target.value;

  // Block zero if it's the first character
  if (input.length === 0 && e.key === "0") {
    e.preventDefault();
    return;
  }

  // Allow digits (0-9) after the first character
  if (!/^\d$/.test(e.key)) {
    e.preventDefault();
  }
};

// this function prevents decimal point an accept only numbers 1 to 9
export const allowAlphabetOnly = (e) => {
  if (
    // Allow: backspace, delete, tab, escape, enter, and .
    [46, 8, 9, 27, 13, 110, 32, 16].includes(e.keyCode) ||
    // Allow: Ctrl+A
    (e.keyCode === 65 && (e.ctrlKey || e.metaKey)) ||
    // Allow: Ctrl+C
    (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) ||
    // Allow: Ctrl+X
    (e.keyCode === 88 && (e.ctrlKey || e.metaKey)) ||
    // Allow: home, end, left, right
    (e.keyCode >= 35 && e.keyCode <= 39)
  ) {
    // Let it happen, don't do anything
    return;
  }
  // Check if the pressed key is not between 'a' (keyCode 65) and 'z' (keyCode 90)
  if (e.keyCode < 65 || e.keyCode > 90) {
    e.preventDefault();
  }
};

export function isCallAvailable() {
  const currentTimeInIST = new Date();
  const currentHourInIST = currentTimeInIST.getHours();

  return currentHourInIST >= NRI_HELPDESK_START_TIME && currentHourInIST < NRI_HELPDESK_END_TIME;
}

export const getOptionLabelInEn = (options, value) => {
  // const option = find(options, { value });
  const option = find(options, { id: value });
  return option ? t(option.name, { lng: "en" }) : "";
};
export const getCookie = (key) => Cookies.get(key);

export const unsetCookie = (key) => Cookies.remove(key);

export const setCookie = (key, data, expiration) =>
  Cookies.set(key, data, {
    expires: expiration,
  });

export const setLocalStorage = (key, data) => {
  if (typeof window !== "undefined" && window.localStorage) {
    window.localStorage.setItem(key, data);
  }
};

export const handleScrollButtonClick = (event, querySelector) => {
  event.preventDefault();
  const target = document.querySelector(querySelector);
  if (target) {
    target.scrollIntoView({ behavior: "smooth" });
  }
};
export const dateTimeToDate = (dateString) => {
  if (!dateString) return false;
  // Split the date string into components
  const [month, day, year] = dateString.split(" ")[0].split("/");

  // Format the date as "d/m/y"
  return `${day}/${month}/${year}`;
};

export const dateTimeToDateQdata = (dateString) => {
  if (!dateString) return false;
  // Split the date string into components
  const [day, month, year] = dateString.split(" ")[0].split("/");

  // Format the date as "d/m/y"
  return `${day}/${month}/${year}`;
};

export const withCurrency = (amount) => `${CURRENCY_SIGN} ${amount}`;

export const isPartnerPersona = () => {
  const query = readQueryParams();
  return query.get("personaa") === PERSONA_LIST.PARTNER;
};
export const isWegaPersona = () => {
  const query = readQueryParams();
  return query.get("persona") === PERSONA_LIST.WEGA;
};

export const isWorkingWomenPersona = () => {
  const query = readQueryParams();
  return query.get("personaa") === PERSONA_LIST.WORKINGWOMEN;
};

export const isTenYearPersona = () => {
  const query = readQueryParams();
  return query.get("persona") === PERSONA_LIST.TENYEARS;
};

export const isInformalPersona = () => {
  const query = readQueryParams();
  return query.get("personaa") === PERSONA_LIST.INFROMAL;
};

export const isEmployeePersona = () => {
  const data = checkPersonaEmployeeQdata();
  const query = readQueryParams();
  return query.get("personaa") === PERSONA_LIST.EMPLOYEE && data;
};

export const isJointLifePersona = () => {
  const query = readQueryParams();
  return query.get("personaa") === PERSONA_LIST.JOINTLIFE;
};

export const getPersonaName = () => {
  const query = readQueryParams();
  return query.get("personaa");
};

export const getPersonaTitle = () => {
  const query = readQueryParams();
  return query.get("persona");
};

export const isAllInOnePersona = () => {
  const persona = getPersonaName();
  return persona === PERSONA_LIST.ALL_IN_ONE;
};

export const isSmartExitPersona = () => {
  const persona = getPersonaName();
  return persona === PERSONA_LIST.SMARTEXIT;
};
export const reFormatDate = (dateStr) => {
  if (!dateStr || typeof dateStr !== "string" || dateStr.trim() === "") {
    return "";
  }
  const parts = dateStr.split("-");
  const [day, month, year] = parts.map((p) => p.padStart(2, "0"));
  return `${day}/${month}/${year}`;
};
export const formatDate = (inputDate) => {
  if (!inputDate) return "";

  if (typeof inputDate === "string") {
    const trimmedDate = inputDate.trim();
    if (trimmedDate === "") return "";

    const parts = trimmedDate.trim().split("/");
    if (parts.length !== 3) return "";

    const [day, month, year] = parts.map((p) => p.padStart(2, "0"));
    return `${year}-${month}-${day}`;
  } else if (inputDate instanceof Date && !isNaN(inputDate)) {
    const day = String(inputDate.getDate()).padStart(2, "0");
    const month = String(inputDate.getMonth() + 1).padStart(2, "0");
    const year = inputDate.getFullYear();

    return `${year}-${month}-${day}`;
  }

  return "";
};

export const formatCountdownTime = (seconds, showSuffix = true) => {
  const mins = Math.floor(seconds / 60)
    .toString()
    .padStart(2, "0");
  const secs = (seconds % 60).toString().padStart(2, "0");
  return `${mins}:${secs}${showSuffix ? "s" : ""}`;
};

export const trimToLength = (str = "", maxLength = 0, addTripleDotsOnExceed = false) => {
  if (str.length <= maxLength) return str;

  const trimmed = str.slice(0, maxLength);
  return addTripleDotsOnExceed ? trimmed + "..." : trimmed;
};

export const getArrivalDateInISO = (date) => {
  if (!date || typeof date !== "string" || !date.includes("/")) return "";
  return convertToISODate(date);
};

export const generateLeadJson = (data) => {
  const queryParams = readQueryParams();
  const { decryptBlowfishQData } = useBlowFish();
  let qData = null;
  if (queryParams.get("qdata") && !isEmpty(queryParams.get("qdata"))) {
    const qDataString = queryParams.get("qdata");

    const str = decryptBlowfishQData(qDataString.replace(/ /g, "+"));
    qData = cleanAndParseJSON(str);
  }

  const visitorId = getCookie("GA_VisitorID") || "";

  const googleSearchQ = queryParams.get("q");
  const staff = data?.staff === OPTION_VALUES.STAFF_Y ? "Yes" : "No";
  const gaVisitorID = generateGaVisitorID();

  const occupations = {
    [OPTION_VALUES.OCCUPATION.SALARIED]: "Salaried",
    [OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE]: "Self-employed",
    [OPTION_VALUES.OCCUPATION.PROFESSIONAL]: "Professional",
    [OPTION_VALUES.OCCUPATION.HOUSEWIFE]: "Housewife",
  };

  let pageUrl = `https://${location.hostname}${location.pathname}`;
  if (location.hostname !== `www.${SITE_DOMAIN}` && location.hostname !== SITE_DOMAIN) {
    pageUrl = `https://www.${SITE_DOMAIN}` + location.pathname;
  }

  const productDetail = getProductDetail();

  //If page name comes from the params use it, then use either standalone or generate it
  const existingPageName = data?.LMS_page_name || data?.LMS_pageName;
  const pageName = existingPageName ? existingPageName : getPageName(data?.LMS_page_name_suffix);

  const productSpecific = `google_search_q-${googleSearchQ || ""},staff-${staff},emp_id-${data?.employeeId},tobacco-${
    data?.tobacco
  },call-${data?.do_not_share_detail ? "No" : "Yes"},vCommId-`;
  const getLms6 = () => {
    if (isProductIWish()) {
      return isIwishAndDependent(data)
        ? IWISH.IWISH_LEADWS_VALUE[data?.lifeAssuredFor]
        : data?.isNegativePincode == OPTION_VALUES.NO
          ? OPTION_VALUES.YES
          : OPTION_VALUES.NO;
    } else {
      return data?.LMS_column_6
        ? data?.LMS_column_6
        : data?.isNegativePincode == OPTION_VALUES.NO
          ? OPTION_VALUES.YES
          : OPTION_VALUES.NO;
    }
  };

  const json = {
    LMS_uid: queryParams.get("UID") || queryParams.get("uid") || "480",
    LMS_product_code: data?.productCode,
    LMS_gender: data?.gender,
    LMS_dob: data?.dob,
    LMS_mobile: data?.mobileno,
    LMS_email: data?.emailid,
    LMS_product_specific: productSpecific,
    LMS_page_name: pageName,
    keyword: "",
    LMS_TRAI_FLAG: data?.trai_flag ? "YES" : "NO",
    matchtype: "",
    LMS_firstName: data?.empFirstName,
    LMS_lastName: data?.empLastName,
    LMS_tobacco: data?.tobacco === OPTION_VALUES.TOBACCO_CONSUMER_YES ? 1 : 0,
    LMS_sumassured: data?.LMS_sumassured || null,
    LMS_premium: data?.LMS_premium || null,
    LMS_deathbenefit: data?.LMS_deathbenefit || "",
    LMS_typeofplan: data?.LMS_typeofplan,
    LMS_payoutoption: data?.LMS_payoutoption,
    LMS_policyTerm: data?.LMS_policyTerm || null,
    LMS_policypaymentfrequency: data?.LMS_policypaymentfrequency || null,
    LMS_premiumterm: data?.LMS_premiumterm || null,
    LMS_CIBenefit: data?.LMS_CIBenefit || 0,
    LMS_staff: staff,
    Lumpsum: 0,
    Monthly_income: 0,
    Term_critical_illness: data?.Term_critical_illness || null,
    LMS_pageName: pageName,
    LMS_pageURL: pageUrl,
    LMS_session_id: "",
    LMS_column_1: 1,
    LMS_column_2: data?.nri === OPTION_VALUES.NRI_YES ? "NRI" : "",
    LMS_column_3: data?.yr_income,
    LMS_column_4: LANGUAGES.forLeads[i18n.language]?.toLowerCase(),
    LMS_column_5: queryParams.get("gclid") || visitorId,
    LMS_column_6: getLms6(),
    LMS_column_7: queryParams.get("UID") || queryParams.get("uid") || "480",
    LMS_column_8: data?.tobacco === OPTION_VALUES.TOBACCO_CONSUMER_YES && data?.tobacco_acceptance ? 1 : "",
    LMS_column_9: data?.calc_occupation === OPTION_VALUES.OCCUPATION.SALARIED ? 1 : "",
    LMS_column_10: qData?.LDUID || "",
    LmsAdditionalDetails: JSON.stringify({
      ...data?.LmsAdditionalDetails,
      ped_prsn_edu: data?.calc_education === "680" ? "Graduate & above" : "Non-Graduate",
      pod_prsn_occptn: occupations[data?.calc_occupation],
      pad_add_pin: data?.pincode,
      pad_add_city: data?.city,
      pad_add_country: data?.country_of_residence,
      country_code: data?.country_code?.toString(),
      pri_frst_nm: data?.pri_frst_nm,
      pod_prsn_orgnstn_nm: data?.pod_prsn_orgnstn_nm,
      utm_campaign: queryParams.get("utm_campaign") || "",
      utm_keyword: queryParams.get("utm_term") || "",
      utm_adcontent: queryParams.get("utm_content") || "",
      utm_source: queryParams.get("utm_source") || "",
      lms_nri: data?.nri === OPTION_VALUES.NRI_YES ? "YES" : "NO",
      nri_in_india: data?.nri === OPTION_VALUES.NRI_YES ? (data?.is_nri_in_india ? "YES" : "NO") : "",
      nri_arvl_in_india: getArrivalDateInISO(data?.nri_india_arriving_date) ?? "",
      quote_page_values: isProductSuper() ? getLocalTime() || "" : data?.quotePageValue || "",
      pref_datetimenew: data?.pref_datetimenew || "", // 2024-06-19T12:00:00.000+05:30
      ...(data?.ind_mobile ? { prop_alt_mobile: data?.ind_mobile } : {}),
      gavisitorid: gaVisitorID,
      ...(isProductSuper() &&
        data?.itr && {
          plantype:
            data?.calc_occupation !== OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE
              ? ""
              : data?.itr === OPTION_VALUES.Y_YES
                ? "ITR:Yes"
                : "ITR:No",
        }),
      ...(isProductIps() &&
        data?.leadForm && {
          plantype: data?.leadForm,
        }),
      ...(isProductOtc() && {
        plantype: productDetail?.planType || "",
      }),
      ...(isProductIWish() &&
        data?.itr && {
          plantype:
            data?.calc_occupation !== OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE
              ? ""
              : data?.itr === OPTION_VALUES.Y_YES
                ? "ITR:Yes"
                : "ITR:No",
        }),
      rider1name: "",
      rider2name: "",
      extra1: "",
      extra2: "",
      extra3: "",
      extra4: "",
      extra5: "",
      extra6: "",
    }),
    // to add suffix in LMS_page_name for appointment
    ...(data?.isAppointment
      ? {
          LMS_page_name_suffix: data?.LMS_page_name_suffix || "",
          isAppointment: data?.isAppointment,
        }
      : {}),
  };

  return json;
};

export const superIpsJson = (data) => {
  const queryParams = readQueryParams();
  const resultJson = {
    appNo: "",
    advisorCode: "",
    source: "BOLEBINEW",
    sourceKey: "BOLEBINEWKEY",
    salesDataReqd: "N",
    dependentFlag: "N",
    sourceTransactionId: "",
    sourceOfFund: "Salary",
    sourceOfFundDesc: "",
    clientId: "",
    uidId: queryParams.get("UID") || queryParams.get("uid") || "480",
    buyersPinCode: "",
    sellersPinCode: "",
    isSuitabilityReq: "N",
    partnerThankYouUrl: "https://www.icicilife.com/thank-you-r.html",

    proposerInfos: {
      frstNm: "",
      lstNm: "",
      mrtlSts: OPTION_VALUES.MARITAL_STATUS.MARRIED,
      dob: updateDate(data?.user_dob),
      gender: OPTION_VALUES.GENDER.MALE,
      isStaff: data?.is_icici_employee ? "1" : "0",
      mobNo: data?.mobileno,
      email: data?.emailid,
    },
    lifeAssrdInfos: {
      frstNm: "",
      lstNm: "",
      mrtlSts: OPTION_VALUES.MARITAL_STATUS.MARRIED,
      dob: updateDate(data?.user_dob),
      gender: OPTION_VALUES.GENDER.MALE,
      isStaff: data?.is_icici_employee ? "1" : "0",
      mobNo: data?.mobileno,
      email: data?.emailid,
    },
    productSelection: {
      sumAssured: "10000000",
      productType: data?.productType,
      productName: data?.productName,
      productId: data?.productCode,
      monthlyIncPer: "",
      RetireMentAge: "",
      premiumPayingFrequency: "Monthly",
      policyTerm: "10",
      premiumPayingTerm: "10",
      deathBenefitOption: "",
      annualSalary: "50000898",
      premiumpaymentoption: "Limited Pay",
      Occupation: data?.calc_occupation,
      CIBenefit: "0",
      tobacco: "0",
      isNRI: "false",
      GstWaiver: "No",
      ADHB: 0,
      Pincode: data?.pincode,
      PincodeDiscount: data?.pincodeDiscount,
      rider1: {
        name: "ADBV",
        sumAssured: "0",
        term: "0",
        percentage: "300",
      },
      rider2: {
        name: "ATPD",
        sumAssured: "0",
        term: "0",
        percentage: "0",
      },
    },
    suitabilityMatrix: {
      income: "",
      lifeStage: "",
      financialAndFamilyGoals: "",
      goalHorizon: "",
      riskProfile: "",
      paymentPreference: "",
    },
    paymentData: {
      pincode: data?.pincode,
      extraAtsInfo: {
        fname: "abc",
        lname: "xyz",
        dob_str: updateDate(data?.user_dob),
        gender: data?.gender,
        sa: 2400000,
      },
    },
    additionalDetails: {
      partnerDataMap: {
        pageName: LMS_CONSTANTS.IPS_SUPER_PAGE_NAME,
        pageURL: LMS_CONSTANTS.IPS_SUPER_PAGE_URL,
      },
    },
  };
  return resultJson;
};

export const iWishJson = (data) => {
  const queryParams = readQueryParams();
  const resultJson = {
    appNo: "",
    advisorCode: "",
    source: "BOLEBINEW",
    sourceKey: "BOLEBINEWKEY",
    salesDataReqd: "N",
    dependentFlag: "N",
    sourceTransactionId: "",
    sourceOfFund: "Salary",
    sourceOfFundDesc: "",
    clientId: "",
    uidId: queryParams.get("UID") || queryParams.get("uid") || "1160",
    buyersPinCode: "",
    sellersPinCode: "",
    isSuitabilityReq: "N",
    partnerThankYouUrl: "https://www.icicilife.com/thank-you-r.html",

    proposerInfos: {
      frstNm: "",
      lstNm: "",
      mrtlSts: OPTION_VALUES.MARITAL_STATUS.MARRIED,
      dob: updateDate(data?.user_dob),
      gender: data?.gender,
      isStaff: data?.is_icici_employee ? "1" : "0",
      mobNo: data?.mobileno,
      email: data?.emailid,
    },
    lifeAssrdInfos: {
      frstNm: "",
      lstNm: "",
      mrtlSts: OPTION_VALUES.MARITAL_STATUS.MARRIED,
      dob: updateDate(data?.user_dob),
      gender: data?.gender,
      isStaff: data?.is_icici_employee ? "1" : "0",
      mobNo: data?.mobileno,
      email: data?.emailid,
    },
    productSelection: {
      sumAssured: "5000000",
      productType: data?.productType,
      productName: data?.productName,
      productId: data?.productCode,
      monthlyIncPer: "",
      RetireMentAge: "",
      premiumPayingFrequency: "Monthly",
      policyTerm: "10",
      premiumPayingTerm: "10",
      deathBenefitOption: "",
      annualSalary: "50000898",
      premiumpaymentoption: "Limited Pay",
      Occupation: data?.calc_occupation,
      CIBenefit: "0",
      tobacco: "0",
      isNRI: "false",
      GstWaiver: "No",
      ADHB: 0,
      Pincode: data?.pincode,
      PincodeDiscount: data?.pincodeDiscount,
      rider1: {
        name: "ADBV",
        sumAssured: "0",
        term: "0",
        percentage: "300",
      },
      rider2: {
        name: "ATPD",
        sumAssured: "0",
        term: "0",
        percentage: "0",
      },
    },
    suitabilityMatrix: {
      income: "",
      lifeStage: "",
      financialAndFamilyGoals: "",
      goalHorizon: "",
      riskProfile: "",
      paymentPreference: "",
    },
    paymentData: {
      pincode: data?.pincode,
      extraAtsInfo: {
        fname: "abc",
        lname: "xyz",
        dob_str: updateDate(data?.user_dob),
        gender: data?.gender,
        sa: 2400000,
      },
    },
    additionalDetails: {
      partnerDataMap: {
        pageName: LMS_CONSTANTS.I_WISH_PAGE_NAME,
        pageURL: LMS_CONSTANTS.I_WISH_PAGE_URL,
      },
    },
  };
  return resultJson;
};

export const readQueryParams = () => {
  const getLocationSearch = () => {
    return new URLSearchParams(history.location.search);
  };

  return getLocationSearch();
};

export const cleanAndParseJSON = (jsonString) => {
  try {
    // Remove non-JSON characters at the end
    let cleanedString = jsonString.replace(/[^}\]]+$/, "");

    // Parse the cleaned JSON string
    let parsedJSON = JSON.parse(cleanedString);

    return parsedJSON;
  } catch (error) {
    // console.error('Invalid JSON string:', error);
    return null;
  }
};

export const scrollToElement = (id) => {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }
};
export const scrollToElementWithOffset = (id, offset = 0) => {
  const element = document.getElementById(id);
  if (element) {
    const elementPosition = element?.getBoundingClientRect().top + window.scrollY;
    const offsetPosition = elementPosition - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  }
};

const getLatestFundObject = (funds = []) => {
  if (!Array.isArray(funds) || !funds.length) return null;
  const sortedFunds = [...funds].sort((a, b) => new Date(b?.InceptionDate) - new Date(a?.InceptionDate));
  return sortedFunds[0];
};

export const getLatestFund = (funds) => {
  if (getNavFundReleasedCode({ fund: funds })) {
    return "";
  }
  const sortedFunds = getLatestFundObject(funds);
  return sortedFunds?.LAfundCode || sortedFunds?.lafundCode || "";
};

export const getLatestFundName = (funds) => {
  if (getNavFundReleasedCode({ fund: funds })) {
    return "";
  }
  const sortedFunds = getLatestFundObject(funds);
  return sortedFunds?.Fund;
};

export const getFundsWithLatestFirst = (funds, property = "Fund") => {
  const latestFundName = FundsStore.getLatestFund();
  const latestFunds = funds.filter((fund) => latestFundName.includes(fund[property]));
  const otherFunds = funds.filter((fund) => !latestFundName.includes(fund[property]));
  return [...latestFunds, ...otherFunds];
};

export const getFundRate = (fundName) => {
  return FUND_RATES[fundName] || 1.35;
};

export const isGreaterThanCurrentDate = (date1) => {
  const [day, month, year] = date1.split("/").map(Number);

  // Create the date using year, month (0-indexed), and day directly
  const firstDate = new Date(year, month - 1, day);
  firstDate.setHours(0, 0, 0, 0); // Set the time to midnight

  // Compare with the current date
  const currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0); // Ensure we compare only the date, not time

  return firstDate > currentDate;
};

export const replaceLanguageInUrl = (oldLang, newLanguage) => {
  const urlObj = new URL(window?.location?.href);
  const path = urlObj.pathname;
  const urlParams = new URLSearchParams(window?.location?.search);

  if (urlParams.has("lan")) {
    // If it doesn't exist, append it with the new language code
    // it is temproary need to remove once ips go live for translation
    urlParams.set("lan", newLanguage);
    return `${urlObj.pathname.replace(`/${oldLang}/`, `/${newLanguage}/`)}?${urlParams.toString()}${urlObj.hash}`;
  }

  // return new url
  if (urlObj.hostname === "localhost") {
    return path.replace(`/${oldLang}/`, `/${newLanguage}/`) + urlObj.search;
  }

  const segments = path.split("/").filter(Boolean);

  if (LANGUAGES.short_codes.includes(segments[0])) {
    segments.shift();
  }

  if (newLanguage === ENGLISH) {
    return `/${segments.join("/")}${urlObj.search}`;
  }

  return `/${newLanguage}/${segments.join("/")}${urlObj.search}`;
};

export const getActiveLanguage = () => {
  const urlParams = new URLSearchParams(window?.location?.search);
  const languageFromParam = urlParams.get(LANGUAGE_PARAM);

  // Persona override
  if (urlParams.get("persona")) {
    return { code: ENGLISH };
  }

  const path = window?.location?.pathname || "";
  const segments = path.split("/");

  const langSet = new Set(LANGUAGES.short_codes);
  // const lang = Array.isArray(segments) && segments.find((seg) => langSet?.has(seg));

  // 🔹 1. Check language in PATH (priority)
  const languageFromPath = segments.find((seg) => langSet.has(seg?.toLowerCase()));

  if (languageFromPath) {
    return { code: languageFromPath.toLowerCase() };
  }

  // 🔹 2. Fallback to URL PARAM
  if (languageFromParam && langSet.has(languageFromParam.toLowerCase())) {
    return { code: languageFromParam.toLowerCase() };
  }

  // 🔹 3. Default fallback
  return { code: LANGUAGES.default };
};
export const isValueInRange = (value, min, max) => {
  return value >= min && value <= max;
};

export const replaceText = (str, search, newValue) => str.replace(search, newValue);

export const capitalize = (str = "") => {
  if (!str) return "";
  return str.slice(0, 1).toUpperCase() + str.slice(1);
};

export const sanitize = (str = "") => {
  if (!str) return "";
  return str
    .replace(/-/g, " ")
    .replace(/[^a-zA-Z0-9\s]/g, "")
    .replace(/\s+/g, " ")
    .trim();
};

export const stripProductPrefix = (productName) => {
  if (!productName) return "";

  return productName.replace(/^(?:icici\s+prudential|icici\s+pru|ipru|ulip\s*:\s*)\s*/i, "").trim();
};

export const getPageName = (pageNameSuffix = "") => {
  if (typeof window === "undefined") return "";
  const product = getProductDetail();
  const rawProductName = CurrentProduct?.getPlanProductName?.() ?? product?.name ?? product?.fullName;
  const curName = stripProductPrefix(rawProductName);
  const persona = getPersonaTitle();
  const currentLanguage = LANGUAGES.options[getActiveLanguage()?.code]?.name || "English";
  return [curName, persona, currentLanguage, pageNameSuffix]
    .map((item) => sanitize(capitalize(item)))
    .filter(Boolean)
    .join(" ");
};

export function convertToWords(num, showOnlyText = "true", t = null) {
  const translate = (key, fallback) => (t ? t(`quote.currency_in_words.${key}`) : fallback);

  const a = [
    "",
    translate("one", "One "),
    translate("two", "Two "),
    translate("three", "Three "),
    translate("four", "Four "),
    translate("five", "Five "),
    translate("six", "Six "),
    translate("seven", "Seven "),
    translate("eight", "Eight "),
    translate("nine", "Nine "),
    translate("ten", "Ten "),
    translate("eleven", "Eleven "),
    translate("twelve", "Twelve "),
    translate("thirteen", "Thirteen "),
    translate("fourteen", "Fourteen "),
    translate("fifteen", "Fifteen "),
    translate("sixteen", "Sixteen "),
    translate("seventeen", "Seventeen "),
    translate("eighteen", "Eighteen "),
    translate("nineteen", "Nineteen "),
  ];
  const b = [
    "",
    "",
    translate("twenty", "Twenty"),
    translate("thirty", "Thirty"),
    translate("forty", "Forty"),
    translate("fifty", "Fifty"),
    translate("sixty", "Sixty"),
    translate("seventy", "Seventy"),
    translate("eighty", "Eighty"),
    translate("ninety", "Ninety"),
  ];
  if (!num) return null;
  if ((num = num.toString()).length > 9) return translate("overflow", "overflow: Maximum 9 digits supported only");
  let n = ("000000000" + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
  if (!n) return;
  var str = "";
  str += n[1] != 0 ? (a[Number(n[1])] || b[n[1][0]] + " " + a[n[1][1]]) + translate("crore", "Crore ") : "";
  str += n[2] != 0 ? (a[Number(n[2])] || b[n[2][0]] + " " + a[n[2][1]]) + translate("lakh", "Lakh ") : "";
  str += n[3] != 0 ? (a[Number(n[3])] || b[n[3][0]] + " " + a[n[3][1]]) + translate("thousand", "Thousand ") : "";
  str += n[4] != 0 ? (a[Number(n[4])] || b[n[4][0]] + " " + a[n[4][1]]) + translate("hundred", "Hundred ") : "";
  str +=
    n[5] != 0 ? (str != "" ? translate("and", "and ") : "") + (a[Number(n[5])] || b[n[5][0]] + " " + a[n[5][1]]) : "";
  try {
    if (parseInt(num) === 0) {
      str = translate("zero", "Zero ");
    }
  } catch {
    return "";
  }

  return str + (showOnlyText ? translate("only", " only ") : "");
}

export const changeUIDInURL = (UID) => {
  const urlObj = new URL(window.location.href);
  const params = new URLSearchParams(urlObj.search);

  // Check if the lan parameter exists
  if (!params.has("UID")) {
    // If it doesn't exist, append it with the new language code
    params.append("UID", UID);
  } else {
    // If it exists, replace its value with the new language code
    params.set("UID", UID);
  }
  if (params.has("persona")) {
    params.delete("persona");
  }
  // return new url
  return `${urlObj.origin}${urlObj.pathname}?${params.toString()}${urlObj.hash}`;
};

const format = (value) => parseFloat(value.toFixed(2));

export const currencyToWord = (num, word = true) => {
  if (!num) return;
  const lakh = 100000;
  const crore = 10000000;

  if (num >= crore) {
    const value = format(num / crore);
    return word ? i18next.t("amount", { context: "crore", count: value }) : value.toString();
  }

  if (num >= lakh) {
    const value = format(num / lakh);
    return word ? i18next.t("amount", { context: "lakh", count: value }) : value.toString();
  }

  return num?.toString();
};

export function removeHTO(value) {
  let digitsToRemove = 3;
  if (value > 10000000) {
    digitsToRemove = 5;
  }

  const factor = Math.pow(10, digitsToRemove);
  const newValue = Math.floor(value / factor) * factor;
  return newValue;
}

export const dropdownPremiumNumberList = ({ start, end, optionText = "", age, isPremiumRefundValid }) => {
  let options = [];
  for (let index = start; index <= end; index++) {
    const { isValid, premiumValue } = isPremiumRefundValid(age, index);
    options.push({ id: index, name: `${index} ${optionText}`.trim(), premiumRefund: isValid, premiumValue });
  }

  return options;
};

export const dropdownNumberList = ({ start, end, optionText = "" }) => {
  let options = [];
  for (let index = start; index <= end; index++) {
    options.push({ id: index, name: `${index} ${optionText}`.trim() });
  }

  return options;
};

// using only in netcore
export const convertToDateTime = (value) => {
  if (value) {
    const [day, month, year] = value.split("/");
    return `${year}-${month}-${day} 06:00:00`;
  }
  return value;
};

export const convertToAmount = (number = 0) =>
  number.toLocaleString("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  });

export const findGreaterThanThreshold = (obj, threshold) => {
  const v = _.findLast(_.keys(obj), (key) => parseInt(threshold) >= key);
  return obj?.[v] || null;
};

export const parseNumber = (value) => {
  if (!value) return "";
  return parseInt(value.replace(/,/g, ""));
};

export const noop = () => {};

export const getUID = () => {
  const urlParams = new URLSearchParams(window?.location?.search);
  return urlParams.get("UID") || "480";
};

export const downloadFileFromUrl = async (fileUrl) => {
  const filename = fileUrl.substring(fileUrl.lastIndexOf("/") + 1);
  const anchorElement = document.createElement("a");
  anchorElement.href = fileUrl;
  anchorElement.download = filename;
  anchorElement.click();
};

export const openFileInNewTab = (fileUrl) => {
  const anchorElement = document.createElement("a");
  anchorElement.href = fileUrl;
  anchorElement.target = "_blank";
  anchorElement.click();
};

// Function to generate the tracerAssociationId
export const tracerAssociationId = async ({ dob, mobile }) => {
  // Extract the year from the dob
  const year = dob.split("/")[2];
  // Get the last 7 digits of the mobile number
  const last7Digits = mobile.toString().slice(-7);

  let associationId = `${year}${last7Digits}`;

  let result = { associationId, ip: "" };

  const ip = await getIpAddress();
  if (ip) {
    result = { ...result, associationIdIp: `${associationId}${ip}`, ip };
  } else {
    console.error("Failed to append IP address");
  }

  return result;
};

//To convert the date format from dd/mm/yyyy to yyyy-mm-dd
export const convertToISODate = (date) => {
  if (!date) return "";
  const [day, month, year] = date.split("/");
  return `${year}-${month}-${day}`;
};

export function appendFormData(data) {
  let formData = new FormData();
  for (const key in data) {
    const value = data[key];
    const formKey = key;

    formData.append(formKey, value);
  }

  return formData;
}
export const getCurrentHostAndPort = () => {
  return `${window?.location?.protocol}//${window?.location?.host}`;
};

export const getModelAPIPath = () => {
  return process.env.REACT_APP_API_HOST || getCurrentHostAndPort();
};

export const removeValidation = (schema, fieldsToRemove = []) => {
  let newSchemaFields = cloneDeep(schema.fields);
  fieldsToRemove.forEach((field) => {
    delete newSchemaFields[field];
  });
  return yup.object(newSchemaFields);
};

export const isPersonaPage = () => {
  const urlParams = new URLSearchParams(history.location.search);
  const personaQueryParam = urlParams.get("personaa");
  // console.log("personaQueryParam - ", personaQueryParam);
  return personaQueryParam ? personaQueryParam : null;
};
export const isBookAppointment = () => {
  const isAppPersona = isPersonaPage() == "Appointment";
  const location = useLocation();
  const url = location.pathname;

  const isBookAppPage = url.includes("book-an-appointment");
  return isAppPersona || isBookAppPage;
};

export const convertToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

export const formattedDate = (date, abbr = false) => {
  const day = String(date.getDate()).padStart(2, "0");
  const month = abbr ? MONTHS_ABBR[date.getMonth()] : String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const year = date.getFullYear();

  const formattedDate = abbr ? `${day}-${month}-${year}` : day + month + year;
  return formattedDate;
};

export const updateDate = (date, mmddyyyy = false) => {
  try {
    const parts = date?.split("/");
    const day = String(parseInt(parts?.[0], 10)).padStart(2, "0");
    const month = parseInt(parts?.[1], 10) - 1;
    const year = parseInt(parts?.[2], 10);
    const formattedDate = mmddyyyy
      ? `${String(month + 1).padStart(2, "0")}/${day}/${year}`
      : `${day}-${MONTHS_ABBR[month]}-${year}`;

    return formattedDate;
  } catch {
    return "";
  }
};
export const parseDateToDisplay = (date) => {
  try {
    if (date?.includes("-")) {
      const parts = date.split("-");
      const day = parts[0].padStart(2, "0");
      const month = String(MONTHS_ABBR.indexOf(parts[1]) + 1).padStart(2, "0");
      const year = parts[2];
      return `${day}/${month}/${year}`; // → "01/12/1999"
    }

    if (date?.includes("/")) return date;

    return "";
  } catch {
    return "";
  }
};

// return in date format 02-01-2001
export const updateDateToNumericMonth = (date) => {
  const parts = date?.split("/");
  const day = String(parseInt(parts?.[0], 10)).padStart(2, "0");
  const month = String(parseInt(parts?.[1], 10)).padStart(2, "0");
  const year = String(parseInt(parts?.[2], 10));
  const formattedDate = `${day}-${month}-${year}`;

  return formattedDate;
};

export const updateDateToNumericFormat = (date) => {
  const parts = date?.split("-");
  const day = String(parseInt(parts?.[2], 10)).padStart(2, "0");
  const month = String(parseInt(parts?.[1], 10)).padStart(2, "0");
  const year = String(parseInt(parts?.[0], 10));
  const formattedDate = `${day}-${month}-${year}`;

  return formattedDate;
};

export const getMonthYear = (date) => {
  const parts = date?.split("/");
  const month = parseInt(parts[0], 10) - 1;
  const year = parseInt(parts[1], 10);
  return MONTHS[month] + year;
};

/**
 *
 * @param {Fund[]} funds
 * @returns {AllocatedFund[]}
 */
export const mapToAllocatedFunds = (funds) => {
  return funds?.map((fund) => ({
    ...fund,
    name: fund.Fund,
    value: getDefaultSelectedFund() === fund.Fund ? 100 : 0,
  }));
};

export const ipruGetParameterByName = (name, query) => {
  if (!query) query = window.location.search;
  name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
  var regexS = "[\\?&]" + name + "=([^&#]*)";
  var regex = new RegExp(regexS);
  var results = regex.exec(query);
  if (results == null) return "";
  else return results[1].replace(/\+/g, " ");
};

export const transformFundOptions = (funds) => {
  return funds.map((fund) => ({
    name: fund.Fund,
    id: fund.Fund,
    assetClass: fund.AssetClass,
    lafundCode: fund.LAfundCode,
    return1yr: fund?.Perf1Year,
    return3yr: fund?.Perf3Year,
    return5yr: fund?.Perf5Year,
    returnRSIyr: fund?.PerfInception,
    return10yr: fund?.Perf10Year,
  }));
};

export const getSelectedFunds = (allocatedFunds = []) => {
  return allocatedFunds.filter((fund) => {
    return parseFloat(fund.value) > 0;
  });
};

export const reArrangeFundData = (data, selectedReturnType) => {
  const rearrangedData = {
    Equity: [],
    Balanced: [],
    Debt: [],
  };

  data.forEach((fund) => {
    rearrangedData[fund?.AssetClass]?.push(fund);
  });

  // Sort each group individually
  Object.keys(rearrangedData).forEach((key) => {
    rearrangedData[key].sort((a, b) => {
      const valueA = parseFloat(a[selectedReturnType]);
      const valueB = parseFloat(b[selectedReturnType]);
      if (isNaN(valueA)) return 1;
      if (isNaN(valueB)) return -1;
      return valueB - valueA;
    });
  });

  return Object.values(rearrangedData).flat();
};

export const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const validateEKYCDetails = ({ kycDob, kycGender, userDob, userGender }) => {
  const kycDobArray = kycDob?.split(/[-/. ]/) || [""];
  const [userDate, userMonth, userYear] = userDob?.split("/") || ["", "", ""];

  let isValid = true;
  let mismatch = null;

  if (userGender !== kycGender) {
    isValid = false;
    mismatch = KYC_MISMATCH_TYPE.GENDER;
  } else if (kycDobArray.length === 3) {
    const [kycDate, kycMonth, kycYear] = kycDobArray;
    if (kycDate !== userDate || kycMonth !== userMonth || kycYear !== userYear) {
      isValid = false;
      mismatch = KYC_MISMATCH_TYPE.DOB;
    }
  } else if (kycDobArray.length === 1) {
    const [kycYear] = kycDobArray;
    if (kycYear !== userYear) {
      isValid = false;
      mismatch = KYC_MISMATCH_TYPE.DOB;
    }
  } else {
    isValid = false;
    mismatch = KYC_MISMATCH_TYPE.DOB;
  }

  return {
    isValid,
    mismatch,
  };
};

export const getCorrectDob = ({ userDob, kycDob }) => {
  let correctedDob = "";
  const [uday, umonth] = userDob?.split("/") || ["", ""];
  const kycDobArray = kycDob?.split(/[-/. ]/) || [""];
  if (kycDobArray?.length === 3) {
    correctedDob = kycDobArray.join("/");
  } else {
    correctedDob = `${uday}/${umonth}/${kycDob}`;
  }

  return correctedDob;
};

/**
 *
 * @param {{line1 : string, line2 : string, line3 : string}} kyc
 * @returns {string}
 */
export const getFullKycAddress = (kyc) => {
  return Object?.values(kyc)?.filter(Boolean)?.join(" ") || "";
};

export const getSplitDropOffAddress = (fullAddress) => {
  const words = fullAddress?.split(" ");

  let address = {
    line1: "",
    line2: "",
    line3: "",
  };

  if (!fullAddress) {
    return address;
  }

  // Handle case when there are no spaces in the address
  if (!fullAddress?.includes(" ")) {
    address.line1 = fullAddress.slice(0, 30);
    address.line2 = fullAddress.slice(30, 60);
    address.line3 = fullAddress.slice(60, 90);
    return address;
  }

  let currentLine = "line1";
  let currentLength = 0;

  words?.forEach((word) => {
    if (currentLength + word?.length + 1 > 30) {
      if (currentLine === "line1") {
        currentLine = "line2";
      } else if (currentLine === "line2") {
        currentLine = "line3";
      }
      currentLength = 0;
    }

    if (currentLength > 0) {
      address[currentLine] += " ";
    }
    address[currentLine] += word;
    currentLength += word.length + 1;
  });

  return address;
};

export const getSplitAddress = (fullAddress, landmark) => {
  let address = {
    line1: "",
    line2: "",
    line3: "",
    landmark: "",
  };
  fullAddress += landmark ? " " + landmark : "";

  if (!fullAddress) {
    return address;
  }

  const newAddress = splitAddress(hygineAddressString(fullAddress), "").map((add) => hygineAddressString(add));

  address.line1 = newAddress[0];
  address.line2 = newAddress[1];
  address.line3 = newAddress[2];
  address.landmark = newAddress[3];
  return address;
};

export const getPublicBasePath = () => {
  return process.env.NODE_ENV === "production" ? BASE_PATH : "";
};

export const getDefaultFields = (fields) => {
  const defaultFields = {};
  fields.forEach((field) => {
    if (typeof field.key === "string") defaultFields[field.key] = field.default ?? "";
  });
  return defaultFields;
};

export const getValue = (options, key1, key2) => {
  const {
    appFormData: { formWizard },
  } = useAppFormContext();
  const value = options.find((item) => item.id == formWizard?.[key1]?.[key2]);
  return value?.name || "";
};

export const getSalaryRange = () => {
  const currentProduct = PathUtils.getMetaPropertyValue("current_product");
  return SALARY_RANGE[currentProduct] || SALARY_RANGE.default;
};

export const getCurrentProductFromMeta = () => {
  const currentProduct = PathUtils.getMetaPropertyValue("current_product");
  return currentProduct;
};

export const getProductDetail = () => {
  const currentProduct = PathUtils.getMetaPropertyValue("current_product");
  return PRODUCT_DETAILS.find((item) => item.key === currentProduct) || {};
};

export const getProductDetailFromName = (productName) => {
  const currentProduct = productName || PathUtils.getMetaPropertyValue("current_product");
  return PRODUCT_DETAILS.find((item) => item.key === currentProduct) || {};
};

export const getCurrentEventName = (isEnglish, step, persona) => {
  const currentLanguage = isEnglish === "TRUE" ? "ENGLISH" : "HINDI";

  const product = EVENT_NAME[currentLanguage][getCurrentProductFromMeta()];
  const currentProduct = persona && product?.[persona] ? product[persona] : product;

  return step === "appFormScreen" ? currentProduct.APPLICATION : currentProduct;
};

export const conditionalRound = (value, threshold = 100000) => {
  if (value >= threshold) {
    return Math.round(value / 1000) * 1000;
  }
  return value;
};

export const scrollToFunds = () => {
  const fundsSection = document.getElementById("funds");
  if (fundsSection) {
    const fundsPosition = fundsSection?.getBoundingClientRect().top + window.scrollY;

    window.scrollTo({
      top: fundsPosition - 80,
      behavior: "smooth",
    });
  }
};

export const getDividerForAddress = (inputString) => {
  let divider = 30;
  if (
    (inputString?.length >= 31 && inputString?.length < 35) ||
    (inputString?.length >= 61 && inputString?.length < 65) ||
    (inputString?.length >= 91 && inputString?.length < 95)
  ) {
    divider = 25;
  }
  return divider;
};

export const splitAddress = (inputString, city) => {
  const maxPartLength = getDividerForAddress(inputString);
  const parts = [];
  let currentIndex = 0;

  while (currentIndex < inputString.length && parts.length < 4) {
    const part = inputString.slice(currentIndex, currentIndex + maxPartLength);
    parts.push(part?.trim());
    currentIndex += maxPartLength;
  }

  // Ensure we have exactly 4 parts, even if some are empty
  while (parts.length < 4) {
    parts.push("");
  }

  if (!parts[0]) {
    parts[0] = city;
  }

  if (!parts[1]) {
    parts[1] = city;
  }

  return parts;
};

export const splitFullName = (fullName) => {
  const MAX_FIRST_NAME_LENGTH = 30;
  const MAX_LAST_NAME_LENGTH = 30;

  const nameParts = fullName?.trim()?.split(" ") ?? [];
  const lastName = nameParts.length > 1 ? nameParts.pop() : "";
  let firstName = nameParts.join(" ");
  let lastNameAdjusted = lastName;

  if (firstName.length > MAX_FIRST_NAME_LENGTH) {
    const words = firstName.split(" ");
    let cutIndex = 0;
    let len = 0;

    for (let i = 0; i < words.length; i++) {
      const addLen = i === 0 ? words[i].length : words[i].length + 1;
      if (len + addLen > MAX_FIRST_NAME_LENGTH) break; // stop at first overflow
      len += addLen;
      cutIndex = i + 1;
    }

    const kept = words.slice(0, cutIndex);
    const overflow = words.slice(cutIndex);

    firstName = kept.join(" ");
    lastNameAdjusted = [...overflow, lastNameAdjusted].filter(Boolean).join(" ");
  }

  if (lastNameAdjusted.length > MAX_LAST_NAME_LENGTH) {
    lastNameAdjusted = lastNameAdjusted.substring(0, MAX_LAST_NAME_LENGTH).trim();
  }

  return { firstName, lastName: lastNameAdjusted };
};

export const splitAndRejoinFullName = (fullName) => {
  const { firstName, lastName } = splitFullName(fullName);
  const truncatedFullName = [firstName, lastName].filter(Boolean).join(" ");
  return truncatedFullName;
};

export const cleanName = (name) => {
  // Remove titles
  name = name.replace(/^(Mr\.?|Mrs\.?|Ms\.?|Dr\.?|Prof\.?|Miss|Master)\s+/i, "");

  // Remove all special characters
  name = name.replace(/[^a-zA-Z\s]/g, "");

  //Remove multiple spaces
  name = name.replace(/\s+/g, " ");

  return name.trim();
};

export const hygieneString = (text) => {
  if (text) {
    // Remove extra spaces between words and trim spaces from start and end
    return text.replace(/\s+/g, " ").trim();
  }
  return text;
};

export const sanitizeAddressInput = (input) => {
  return input ? input.replace(/[^a-zA-Z0-9]/g, "") : "";
};

export function hygineAddressString(inputString) {
  if (!inputString) return "";
  inputString = inputString.trim();
  inputString = inputString.replace(/\s+/g, " ");
  inputString = inputString.replace(/[^a-zA-Z0-9 .,/'-]/g, "");
  inputString = inputString.replace(/^[^a-zA-Z0-9.'\s]+|[^a-zA-Z0-9.'\s]+$/g, "");
  return inputString;
}

export function hygieneKycAddressString(inputString) {
  if (!inputString) return "";
  inputString = inputString.trim();
  inputString = inputString.replace(/\s+/g, " ");
  inputString = inputString.replace(/[^a-zA-Z0-9 .,/\\-]/g, "");
  inputString = inputString.replace(/^[^a-zA-Z0-9.\s]+|[^a-zA-Z0-9.\s]+$/g, "");
  inputString = inputString.replace(/([\\/,.-]){2,}/g, "$1");
  if (/^[\\/,.-]+$/.test(inputString)) return "";
  inputString = inputString.replace(/^[\\/,.-]\s/, "");
  inputString = inputString.replace(/\s[\\/,.-]+$/, "");
  return inputString.trim();
}

export function hygineAddressStringPartner(inputString) {
  if (!inputString) return "";
  inputString = inputString.trim();
  inputString = inputString.replace(/\s+/g, " ");
  inputString = inputString.replace(/[^a-zA-Z0-9 .,/'-]/g, "");
  inputString = inputString.replace(/^[^a-zA-Z0-9.'\s]+|[^a-zA-Z0-9.'\s]+$/g, "");
  if (inputString.length > 30) {
    inputString = inputString.slice(0, 30);
  }
  return inputString;
}

export function hygineCity(inputString) {
  if (!inputString) return "";
  inputString = inputString.trim();
  inputString = inputString.replace(/\s+/g, " ");
  inputString = inputString.replace(/[^\w\s]/g, "");
  return inputString;
}

export function hyginePincode(text) {
  return text ? text?.trim() : "";
}

export function cleanUpString(input) {
  // Remove extra spaces
  if (input.includes(undefined)) input = "";
  let cleaned = input.replace(/\s+/g, " ").trim();

  // Reduce more than 2 consecutive characters to 2
  cleaned = cleaned.replace(/(.)\1{2,}/g, "$1$1");

  return cleaned;
}

export const addDynamicScript = (url, callback = noop) => {
  const script = document.createElement("script");
  script.src = url;
  script.async = true;
  script.onload = callback;
  document.body.appendChild(script);
};

export const addGtmScript = () => {
  const script = document.createElement("script");
  script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','GTM-QSFV');`;
  document.head.appendChild(script);
};
export const getDiscountCount = (breakup) => {
  let count = 0;
  if (breakup?.femaleDiscount > 0) {
    count++;
  }
  if (breakup?.onlineDiscountPercent > 0) {
    count++;
  }
  if (breakup?.salariedDiscountAmt > 0) {
    count++;
  }
  return count;
};

export const adharNumberMasking = (str) => {
  const lastFourDigits = str?.toString()?.slice(-4); // Extract the last four digits
  const maskedAdhar = `12121212${lastFourDigits}`; // Replace all but the last 4 digits with "12"
  return { maskedAdhar, lastFourDigits };
};

export const getDiscountText = ({ breakup, staff, t }) => {
  let text = "";
  if (breakup?.femaleDiscount > 0) {
    text += `${breakup.femaleDiscountPercent}% ${t(`quote.women_discount_info`)} + `;
  }
  if (breakup?.onlineDiscountPercent > 0) {
    text += `${breakup.onlineDiscountPercent}% ${t(
      staff === OPTION_VALUES.STAFF_Y ? `quote.staff_discount_info` : `quote.online_discount_info`
    )}`;
  }
  if (breakup?.salariedDiscountAmt > 0) {
    text += ` + ${breakup.salariedDiscountPercent}${t("quote.salaried_discount_info")}`;
  }
  return text;
};

export const getSuperDiscountText = ({ discounts }) => {
  let text = "";
  if (discounts?.onlineDiscount > 0) {
    text += `${discounts.onlineDiscount}% ${t(`quote.online_discount_info`)}`;
  }
  if (discounts?.loyaltyDiscount > 0) {
    text += ` + ${discounts.loyaltyDiscount}% ${t(`ipssuper.quote.labels.loyalty_discount_info`)} `;
  }
  if (discounts?.femaleDiscountPercent > 0) {
    text += ` + ${discounts.femaleDiscountPercent}% ${t("quote.women_discount_info")}`;
  }
  if (discounts?.topCityDiscount > 0) {
    text += ` + ${discounts.topCityDiscount}% ${t("ipssuper.quote.labels.pincode_discount_info")}`;
  }
  return text;
};

export const heightInCm = (feet, inches) => {
  if (feet && inches) return Math.round(parseInt(feet) * 30.48 + parseInt(inches) * 2.54);
};

export const convertHeight = (feet, inches) => {
  if (feet && inches) {
    return `${feet} feet ${inches} inches`;
  }
};

export const parseHeight = (data) => {
  if (typeof data === "string") {
    const [feet = "", , inches = ""] = data.split(" ");
    return { feet, inches };
  }
  return { feet: "", inches: "" };
};
export const updateAgeWiseFund = (fundFields, multiCapValue, incomeFundValue) => {
  const updatedFunds = fundFields.map((el) => {
    if (el.Fund === FUND_NAMES.INCOME_FUND.value) {
      return { ...el, value: incomeFundValue };
    } else if (el.Fund === FUND_NAMES.MULTI_CAP_GROWTH_FUND.value) {
      return { ...el, value: multiCapValue };
    } else {
      return { ...el, value: 0 };
    }
  });
  return updatedFunds;
};

export const findAgeRange = (ageWiseFund, age) => {
  for (let i = 0; i < ageWiseFund.length; i++) {
    if (age >= ageWiseFund[i].min && age <= ageWiseFund[i].max) {
      return i;
    }
  }
  return null;
};

export const validateIsAddressSimilar = (pData) => {
  const perAdd = {
    fullAdd: pData?.per_full_address,
    state: String(pData?.per_state),
    city: pData?.per_city?.toLowerCase(),
    pinCode: String(pData?.per_pincode),
  };

  const commAdd = {
    fullAdd: pData?.full_address,
    state: String(pData?.state),
    city: pData?.city?.toLowerCase(),
    pinCode: String(pData?.pincode),
  };

  return JSON.stringify(commAdd) === JSON.stringify(perAdd);
};

export const valueIsInArray = (value, array) => {
  if (array.includes(value)) {
    return value;
  }
  return "";
};

export const clipString = (str = "", length = 0) => {
  return str.length > length ? str.slice(0, length) : str;
};

export async function fireConversion() {
  if (window.gtag) {
    const leadCode = "AW-850485213/_YmnCM7yj_kZEN2_xZUD";
    window.gtag("event", "conversion", {
      send_to: leadCode,
    });
  } else {
    console.log("gtag is not available.");
  }
}

export const generateGaVisitorID = () => {
  const gaVisitorID = getCookie("_ga") || "";
  const parts = gaVisitorID.split(".");
  const trimmedGaVisitorId = parts.length > 2 ? parts.slice(2).join(".") : gaVisitorID;
  return trimmedGaVisitorId;
};

export const setApointeeNomineegender = (relation) => {
  const { FATHER, HUSBAND, GRAND_FATHER, GRAND_SON, NEPHEW, SON, UNCLE, BROTHER, BROTHER_IN_LAW } =
    OPTION_VALUES.NOMINEE_RELATIONSHIP;

  const {
    GRAND_FATHER: GF_OTHER,
    GRAND_SON: GS_OTHER,
    NEPHEW: NEPHEW_OTHER,
    UNCLE: UNCLE_OTHER,
    BROTHER: BROTHER_OTHER,
    BROTHER_IN_LAW: BIL_OTHER,
  } = OPTION_VALUES.NOMINEE_RELATIONSHIP_OTHERS;

  const maleRelations = [
    FATHER,
    HUSBAND,
    GRAND_FATHER,
    GRAND_SON,
    NEPHEW,
    SON,
    UNCLE,
    BROTHER,
    BROTHER_IN_LAW,
    // from OTHERS
    GF_OTHER,
    GS_OTHER,
    NEPHEW_OTHER,
    UNCLE_OTHER,
    BROTHER_OTHER,
    BIL_OTHER,
  ];

  return maleRelations.includes(relation) ? "Male" : "Female";
};

export const getOrdinalSuffix = (number) => {
  const suffixes = ["th", "st", "nd", "rd"];
  const remainder = number % 100;

  // Check for 11th, 12th, and 13th which are exceptions
  if (remainder >= 11 && remainder <= 13) {
    return `${number}${suffixes[0]}`;
  }

  switch (number % 10) {
    case 1:
      return `${number}${suffixes[1]}`; // st
    case 2:
      return `${number}${suffixes[2]}`; // nd
    case 3:
      return `${number}${suffixes[3]}`; // rd
    default:
      return `${number}${suffixes[0]}`; // th
  }
};

export const getAgeBracket = (age) => {
  if (age < 30) return "<30";
  if (age <= 40) return "31-40";
  if (age <= 50) return "41-50";
  return ">50";
};
export const checkOrganisationInList = ({ list, value }) => {
  const find = list.find((item) => item.toLowerCase() === value.toLowerCase());
  return find ? true : false;
};

export const removeMultipleSpaceFromJson = (jsonData) => {
  let jsonString = JSON.stringify(jsonData);
  jsonString = jsonString.replace(/\s+/g, " ");
  const cleanedJson = JSON.parse(jsonString);
  return cleanedJson;
};

export const getNumericMonth = (month) => {
  const numericMonth = PAYMENT_MONTHS.findIndex((m) => m.id === month);
  if (numericMonth === -1) {
    return "";
  }
  return numericMonth.toString().padStart(2, "0");
};
export const isProductSuper = () => {
  const productMetaName = getCurrentProductFromMeta();

  return productMetaName === PRODUCT_KEYS.IPS_SUPER;
};

export const isProductIWish = () => {
  const productMetaName = getCurrentProductFromMeta();
  return productMetaName === PRODUCT_KEYS.IWISH;
};
export const isProductIPrime = () => {
  const productMetaName = getCurrentProductFromMeta();
  return productMetaName === PRODUCT_KEYS.ICARE;
};

export const isIwishAndDependent = (calFormData) => {
  return (
    isProductIWish() &&
    calFormData?.lifeAssuredFor != OPTION_VALUES.IWISH_BUYING_FOR.SELF &&
    calFormData?.lifeAssuredFor != undefined
  );
};

export const isNotIwishAndFemale = () => {
  const { calculatorFormData } = GlobalStore.getSnapshot();

  if (isIwishAndDependent(calculatorFormData)) return false;
  return !(isProductIWish() && calculatorFormData?.gender === OPTION_VALUES.GENDER.FEMALE);
};

export const isProductIps = () => {
  const productMetaName = getCurrentProductFromMeta();
  return productMetaName === PRODUCT_KEYS.IPS;
};

export const isProductOtc = () => {
  const productMetaName = getCurrentProductFromMeta();
  return productMetaName === PRODUCT_KEYS.OTC_SJB;
};

export const isProductPnG = () => {
  const productMetaName = getCurrentProductFromMeta();
  return productMetaName === PRODUCT_KEYS.PNG;
};

export const isProductGiftCity = () => {
  const productMetaName = getCurrentProductFromMeta();
  return productMetaName === PRODUCT_KEYS.GIFT_CITY;
};

export const isProductWealthAccelerator = () => {
  const productMetaName = getCurrentProductFromMeta();
  return productMetaName === PRODUCT_KEYS.GLOBAL_WEALTH_ACCELERATOR;
};

export const isProductSaralPension = () => {
  const productMetaName = getCurrentProductFromMeta();
  return productMetaName === PRODUCT_KEYS.SARAL_PENSION;
};

export const isProductGpp = () => {
  const productMetaName = getCurrentProductFromMeta();
  return productMetaName === PRODUCT_KEYS.GPP;
};
export const isProductSignaturePension = () => {
  const productMetaName = getCurrentProductFromMeta();
  return productMetaName === PRODUCT_KEYS.SIGNATURE_PENSION;
};

export const getProductNameFromCode = (productCode) => {
  for (const [productName, code] of Object.entries(PRODUCT_CODES)) {
    if (code === productCode) {
      return PRODUCT_KEY[productName];
    }
  }
  return null;
};

export const getProductCodeByKey = (key) => PRODUCT_DETAILS.find((product) => product.key === key)?.code ?? "";

export const isProductSmartKidAssure = () => {
  const productMetaName = getCurrentProductFromMeta();
  return productMetaName === PRODUCT_KEYS.SMARTKID_ASSURE;
};

export const isProductAssure = () => {
  const productMetaName = getCurrentProductFromMeta();
  const assureProducts = [PRODUCT_KEYS.SIGNATURE_ASSURE, PRODUCT_KEYS.SMARTKID_ASSURE];
  return assureProducts?.includes?.(productMetaName);
};

export const isProductGppFlexi = () => {
  const productMetaName = getCurrentProductFromMeta();
  return productMetaName === PRODUCT_KEYS.GPP_FLEXI;
};

export const isProductIPROP = () => {
  const productMetaName = getCurrentProductFromMeta();
  return productMetaName === PRODUCT_KEYS.IPROP;
};

export const isProductGPPIA = () => {
  const { quoteFormData } = GlobalStore.getSnapshot();
  return isProductGpp() && !GPP_ANNUITY_OPTION_DA.includes(quoteFormData?.AnnuityOption);
};

export const getFactor = ({ frequency }) => {
  switch (frequency) {
    case OPTION_VALUES.PAYMENT_FREQUENCY.MONTHLY:
      return 12;
    case OPTION_VALUES.PAYMENT_FREQUENCY.HALF_YEARLY:
      return 2;
    case OPTION_VALUES.PAYMENT_FREQUENCY.YEARLY:
      return 1;
    default:
      return 1;
  }
};

export const checkProductEligibility = (key) => {
  const currentProduct = getCurrentProductFromMeta();
  const eligibilityInfo = ProductFieldEligibility[key];
  if (eligibilityInfo) {
    let isCurrentProductExist = eligibilityInfo.products?.includes(currentProduct);
    return eligibilityInfo.isEligibleForProduct ? isCurrentProductExist : !isCurrentProductExist;
  }
  return false;
};
export const isStampAllowed = () => {
  const productMetaName = getCurrentProductFromMeta();
  return STAMP_ALLOWED_PRODUCTS.includes(productMetaName);
};

export const trueFalse = (val) => {
  const inputValue = val?.toLowerCase();

  if (TRULY.includes(inputValue)) {
    return OPTION_VALUES.TRUE;
  } else if (FALSY.includes(inputValue)) {
    return OPTION_VALUES.FALSE;
  } else {
    return "";
  }
};
export const getProductDetails = (keys = []) => {
  const productName = getCurrentProductFromMeta();

  const productDetails = {
    "signature-ulip": {
      category: PRODUCT_CATEGORIES.Saving,
      productType: PRODUCT_CATEGORIES.ULIP,
      productName: PRODUCT_NAMES.Signature,
      productNameExd: PRODUCT_NAMES.iciciPruSignature,
      productId: PRODUCT_CODES.signature,
      pdtName: PRODUCT_SHORT_NAME.signature,
      getProductId: () => PRODUCT_CODES.signature,
    },
    png: {
      category: PRODUCT_CATEGORIES.Protection,
      productType: PRODUCT_CATEGORIES.ULIP,
      productName: PRODUCT_NAMES.iciciPruPnG,
      productNameExd: PRODUCT_NAMES.iciciPruPnG,
      productId: PRODUCT_CODES.png,
      pdtName: PRODUCT_SHORT_NAME.png,
      getProductId: () => PRODUCT_CODES.png,
    },
    "gpp-flexi": {
      productType: PRODUCT_CATEGORIES.Retirement,
      productName: PRODUCT_NAMES.iciciPruGpp,
      productNameExd: PRODUCT_NAMES.iciciPruGpp,
      productId: PRODUCT_CODES.gppFlexi,
      pdtName: PRODUCT_SHORT_NAME.gppFlexi,
      getProductId: () => PRODUCT_CODES.gppFlexi,
    },
    // TODO remove this use only one parent object
    "signature-assure": {
      category: PRODUCT_CATEGORIES.Saving,
      productType: PRODUCT_CATEGORIES.ULIP,
      productName: PRODUCT_NAMES.SignatureAssured,
      productNameExd: "ICICI Life Signature Assure",
      productId: "UB9",
      pdtName: "SigAssure",
      getProductId: () => "UB9",
    },
    "saral-pension": {
      productType: PRODUCT_CATEGORIES.Traditional,
      productName: PRODUCT_NAMES.iciciPruSaral,
      productNameExd: PRODUCT_NAMES.iciciPruSaral,
      productId: PRODUCT_CODES.saralPension,
      pdtName: PRODUCT_SHORT_NAME.SARAL_PENSION,
      getProductId: () => PRODUCT_CODES.saralPension,
    },
    [PRODUCT_KEYS.SIGNATURE_YOUTH]: {
      productType: PRODUCT_CATEGORIES.ULIP,
      productName: PRODUCT_NAMES.iciciSipPlus,
      productNameExd: PRODUCT_NAMES.iciciSipPlus,
      productId: PRODUCT_CODES.sipPlus,
      getProductId: () => PRODUCT_CODES.sipPlus,
    },
    [PRODUCT_KEYS.OTC_SJB]: {
      productType: PRODUCT_CATEGORIES.Protection,
      productName: PRODUCT_NAMES.otc,
      productNameExd: PRODUCT_NAMES.otc,
      productId: PRODUCT_CODES.otc,
      getProductId: () => PRODUCT_CODES.otc,
    },
    [PRODUCT_KEYS.UNIFIED_PLAN]: {
      productType: PRODUCT_CATEGORIES.ULIP,
      productName: PRODUCT_NAMES.UnifiedPlan,
      productNameExd: PRODUCT_NAMES.UnifiedPlan,
      productId: PRODUCT_CODES.UnifiedPlan,
      getProductId: () => PRODUCT_CODES.UnifiedPlan,
    },
    [PRODUCT_KEYS.GIFTPRO]: {
      productType: PRODUCT_TYPES.traditional,
      productName: PRODUCT_NAMES.iciciPruGiftPro,
      productNameExd: PRODUCT_NAMES.iciciPruGiftPro,
      productId: PRODUCT_CODES.giftPro,
      getProductId: () => PRODUCT_CODES.giftPro,
    },
    [PRODUCT_KEYS.OTC_SJB]: {
      productType: PRODUCT_CATEGORIES.Protection,
      productName: PRODUCT_NAMES.otc,
      productNameExd: PRODUCT_NAMES.otc,
      productId: PRODUCT_CODES.otc,
      getProductId: () => PRODUCT_CODES.otc,
    },
    [PRODUCT_KEYS.SIGNATURE_SECURE]: {
      category: PRODUCT_CATEGORIES.Saving,
      productType: PRODUCT_CATEGORIES.ULIP,
      productName: PRODUCT_NAMES.SignatureSecure,
      productNameExd: PRODUCT_NAMES.SignatureSecure,
      productId: PRODUCT_CODES.sigSecure,
      getProductId: () => PRODUCT_CODES.sigSecure,
    },
  };

  const details = productDetails[productName];

  if (keys.length === 0) {
    return details;
  }

  return keys.reduce((acc, key) => {
    if (details[key] !== undefined) {
      acc[key] = details[key];
    }
    return acc;
  }, {});
};
export const buildNomineeInfoList = (nominees = []) =>
  nominees.map((n) => {
    const relation = n.nominee_relationship_others || n.nominee_relationship;
    const base = {
      frstNm: n.nominee_first_name,
      lstNm: n.nominee_last_name,
      dob: updateDate(n.nominee_dob),
      gender: relation ? setApointeeNomineegender(relation) : "",
      relationship: relation,
      reasonNonBloodRelation: n.nominee_non_blood ?? "",
      ...(n.nominee_reason_text && { otherReasonForNonBloodRelation: n.nominee_reason_text ?? "" }),
      ...(n.nominee_mobile && { mobile: n.nominee_mobile ?? "" }),
      ...(n.nominee_email && { email: n.nominee_email ?? "" }),
      sharePercentage: n.nominee_share_percentage,
    };
    if (getAge(n.nominee_dob) < 18) {
      base.apnteDtls = {
        frstNm: n.appointee_first_name,
        lstNm: n.appointee_last_name,
        gender: (n.appointee_relationship && setApointeeNomineegender(n.appointee_relationship)) || "",
        dob: updateDate(n.appointee_dob),
        relationship: n.appointee_relationship,
        ...(n.appointee_mobile && { mobile: n.appointee_mobile }),
      };
    }
    return base;
  });

export const isProtectionPlan = () => {
  const productCategory = getProductDetails(["category"]);
  return productCategory?.category === PRODUCT_CATEGORIES.Protection;
};

export const convertDateToReadableFormat = (dateString) => {
  if (!dateString) return "";
  const [day, month] = dateString.split("/").map(Number);
  const monthName = MONTHS_SHORT_NAME[month - 1];
  const daySuffix =
    day % 10 === 1 && day !== 11
      ? "st"
      : day % 10 === 2 && day !== 12
        ? "nd"
        : day % 10 === 3 && day !== 13
          ? "rd"
          : "th";

  if (i18n.language == "hi") {
    const hindiMonthName = HINDI_MONTHS_NAME[month - 1];
    return `${day} ${hindiMonthName}`;
  }
  return `${day}${daySuffix} ${monthName}`;
};

export const isBMIALLOWED = ({ weight, heightInInches }) => {
  const heightInMeter = heightInInches * 0.0254;
  const bmi = weight / (heightInMeter * heightInMeter);
  if (bmi < 17 || bmi > 38) {
    return false;
  }
  return true;
};

export const getGender = (gender) => {
  if (gender == "M") {
    return OPTION_VALUES.GENDER.MALE;
  } else if (gender == "F") {
    return OPTION_VALUES.GENDER.FEMALE;
  }

  return gender;
};

export const fireCTEvent = ({ eventName, eventData }) => {
  if (!eventName) {
    return;
  }

  console.log("CTEVENT", eventName, eventData);
  try {
    let message = { action: "recordEventWithProps", event: eventName, properties: eventData };
    if (window?.webkit && window?.webkit?.messageHandlers && window?.webkit?.messageHandlers?.MobileAppCTiOS) {
      window.webkit.messageHandlers.MobileAppCTiOS.postMessage(message);
    }
  } catch (e) {
    console.log("CTEVENT failed for android");
  }
  try {
    if (window?.MobileAppCT) {
      window.MobileAppCT.pushEvent(eventName, JSON.stringify(eventData));
    }
  } catch (e) {
    console.log("CTEVENT failed for ios");
  }
};
export const pushCTProfile = ({ siteProfileData }) => {
  console.log("CTEVENT profile", siteProfileData);

  try {
    if (window.MobileAppCT) {
      window.MobileAppCT.pushProfile(JSON.stringify(siteProfileData));
    }
  } catch (e) {
    console.log("failed to send the ct profile for android");
  }

  try {
    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.MobileAppCTiOS) {
      const message = { action: "profilePush", properties: siteProfileData };

      window.webkit.messageHandlers.MobileAppCTiOS.postMessage(message);
    }
  } catch (e) {
    console.log("failed to send the ct profile for ios");
  }
};

export const getCteventData = (appFormData) => {
  const fullName = appFormData?.formWizard?.personalDetails?.full_name?.split(" ");
  const productName = productCTName[getCurrentProductFromMeta()];
  return {
    [`${productName}_ProceedtoPayment_FirstName`]: fullName[0] || "",

    [`${productName}_ProceedtoPayment_LastName`]: fullName[1] || "",

    [`${productName}_ProceedtoPayment_ApplicationNumber`]: appFormData?.appNO,
  };
};
export const currencyToWordShort = (num, word = true) => {
  if (!num) return;
  const lakh = 100000;
  const crore = 10000000;

  if (num >= crore) {
    const value = format(num / crore);
    return word ? i18next.t("amount", { context: "crore_short", count: value }) : value.toString();
  }

  if (num >= lakh) {
    const value = format(num / lakh);
    return word ? i18next.t("amount", { context: "lakh_short", count: value }) : value.toString();
  }

  return num.toString();
};

export function convertDate(input) {
  const months = {
    jan: "01",
    feb: "02",
    mar: "03",
    apr: "04",
    may: "05",
    jun: "06",
    jul: "07",
    aug: "08",
    sep: "09",
    oct: "10",
    nov: "11",
    dec: "12",
  };
  const [day, mon, year] = input.split("-");
  const fullYear = parseInt(year) > 50 ? "19" + year : "20" + year; // assumes cutoff year is 50
  return `${day}/${months[mon?.toLowerCase()]}/${fullYear}`;
}

const incomeBrackets = [
  { returnValue: OPTION_VALUES.ANNUAL_INCOME.ONE_L_FIFTY_K, range: { min: 0, max: 290000 } },
  { returnValue: OPTION_VALUES.ANNUAL_INCOME.FOUR_L, range: { min: 290001, max: 490000 } },
  { returnValue: OPTION_VALUES.ANNUAL_INCOME.SIX_L_FIFTY_K, range: { min: 490001, max: 790000 } },
  { returnValue: OPTION_VALUES.ANNUAL_INCOME.NINE_L, range: { min: 790001, max: 990000 } },
  { returnValue: OPTION_VALUES.ANNUAL_INCOME.FIFTEEN_L, range: { min: 990001, max: 1990000 } },
  { returnValue: OPTION_VALUES.ANNUAL_INCOME.TWENTY_L, range: { min: 1990001, max: Infinity } },
];

export function getClosestIncome(val) {
  const income = val && parseInt(val);
  if (!incomeBrackets.length || typeof income !== "number") {
    return null; // Handle edge cases
  }

  const bracket = incomeBrackets.find(({ range }) => income >= range.min && income <= range.max);
  return bracket ? bracket.returnValue : null;
}

export const getAnnuityOptions = ({ annuityOption, relation = "Self" }) => {
  if (!annuityOption) {
    return [];
  }

  const baseOptions = OPTION_VALUES.ANNUITY_OPTIONS[annuityOption] || [];
  const relationOptions = OPTION_VALUES.ANNUITY_OPTION_RELATION[relation]?.[annuityOption] || [];

  return relationOptions.length > 0 ? relationOptions : baseOptions;
};

export const isDevPartner = () => {
  const query = readQueryParams();
  return query.get("partner") === PARTNER_LIST.DEV || query.get("partner") === PARTNER_LIST.DEV1;
};
export const getDevPartner = () => {
  const query = readQueryParams();
  return query.get("partner");
};
export const getProductLogo = () => {
  const productMetaName = getCurrentProductFromMeta();
  return PRODUCTS_LOGO?.[productMetaName] || PRODUCTS_LOGO.ips;
};

export const getProductTitle = () => {
  const productMetaName = getCurrentProductFromMeta();
  return PRODUCT_TITLE?.[productMetaName] || PRODUCT_TITLE.ips;
};

export const getReverseRelation = (proposerGender, relation) => {
  const { MOTHER, DAUGHTER, WIFE, SON, FATHER, SPOUSE } = OPTION_VALUES.NOMINEE_RELATIONSHIP;

  const maleReverseRelations = {
    [MOTHER]: SON,
    [DAUGHTER]: FATHER,
    [WIFE]: SPOUSE,
  };

  const femaleReverseRelations = {
    [MOTHER]: DAUGHTER,
    [DAUGHTER]: MOTHER,
    [WIFE]: SPOUSE,
  };

  if (proposerGender == OPTION_VALUES.GENDER.FEMALE) {
    return femaleReverseRelations[relation] || "";
  } else {
    return maleReverseRelations[relation] || "";
  }
};

export const isLigoProduct = () => {
  const productMetaName = getCurrentProductFromMeta();
  return LIGO_PRODUCTS.includes(productMetaName);
};

export const getNetCorePageInputs = (formFields) => {
  const {
    empName = "",
    gender,
    country,
    country_code,
    tobacco,
    user_dob: dob,
    staff,
    mobileno,
    emailid,
    calc_occupation,
    calc_education,
    city,
    pincode,
    yr_income,
    state,
    employeeId = "",
    nri,
    isNegativePincode,
    do_not_share_detail,
    is_icici_employee,
    isTopCity,
  } = formFields;
  return {
    dob,
    AnnualIncome: yr_income,
    Email: emailid,
    EmailId: emailid,
    Mobile: mobileno,
    MobileNo: mobileno,
    gender,
    pincode: pincode,
    city: city,
    City: city,
    State: state,
    isNegativePincode: isNegativePincode,
    isTopCity,
    Education: calc_education,
    Occupation: calc_occupation,
    Nri: nri,
    countryName: country,
    countryCode: country_code,
    country: country,
    useTobacco: tobacco,
    staff,
    is_icici_employee,
    fullname: empName,
    employeeId,
    do_not_share_detail,
  };
};

export const isPennyDropProduct = () => {
  // blocking penny drop in development mode
  if (typeof window !== "undefined") {
    const isLocalhost = window.location.hostname === "localhost";
    const searchParams = new URLSearchParams(window.location.search);
    const has1309 = [...searchParams.values()].includes("1309");

    if (isLocalhost || has1309) {
      return false;
    }
  }
  const productMetaName = getCurrentProductFromMeta();
  return PENNY_DROP_ELIGIBLE_PRODUCTS.includes(productMetaName);
};

export const isProductSipPlus = () => {
  const productMetaName = getCurrentProductFromMeta();
  return productMetaName === PRODUCT_KEYS.SIGNATURE_YOUTH;
};
export const generateEncryptedQdata = ({ formFields }) => {
  const { encryptBlowfish } = useBlowFish({ key: APP_KEY_BLOWFISH2 });

  const qData = getLeadPageInputs(formFields);
  return encryptBlowfish(JSON.stringify(qData));
};

export const generateGraphData = ({ investmentReturn, totalInvestment, years }) => {
  const returnData = investmentReturn;

  if (!Array.isArray(returnData)) return [];

  const staticYears = years || [5, 10, 15, 20, 25];

  const filteredData = returnData?.filter((item) => staticYears?.includes(item.Year));

  const data = filteredData.reduce((acc, item) => {
    const yearLabel = `${item.Year}Y`;
    const investment = item.AnnualPremium * parseInt(item.Year);
    const fund = investment === 0 ? totalInvestment : investment;

    const growth = item.ValueBenefit;
    const growthRate = 0;

    acc.push({
      year: yearLabel,
      fund,
      growth,
      growthRate,
    });

    return acc;
  }, []);

  return data;
};

export const fetchDecryptParseQdata = () => {
  const { decryptBlowfishQData } = useBlowFish();

  const queryParams = readQueryParams();
  const qDataString = queryParams.get("qdata");

  if (!qDataString) return "";

  const str = decryptBlowfishQData(qDataString.replace(/ /g, "+"));
  const qData = cleanAndParseJSON(str);

  return qData || "";
};

export const getNomineeGender = (relation) => {
  const gender = [
    OPTION_VALUES.NOMINEE_RELATIONSHIP.FATHER,
    OPTION_VALUES.NOMINEE_RELATIONSHIP.SON,
    OPTION_VALUES.NOMINEE_RELATIONSHIP.BROTHER,
    OPTION_VALUES.NOMINEE_RELATIONSHIP.HUSBAND,
  ].includes(relation)
    ? OPTION_VALUES.GENDER.MALE
    : OPTION_VALUES.GENDER.FEMALE;
  return gender;
};

export const submitEncryptedForm = (encryptedJson) => {
  const form = document.createElement("form");
  form.method = "POST";
  form.action = "https://buyuat.iprulifeinsurance.com/digiuatnew/PartnerIntegration.htm";

  const input = document.createElement("input");
  input.type = "hidden";
  input.name = "bolData";
  input.value = encryptedJson;

  form.appendChild(input);
  document.body.appendChild(form);
  form.submit();
};

export const changeUrlForLocalMachines = (sourceURL) => {
  if (sourceURL.includes("localhost")) {
    // Replace base URL if running on localhost
    const urlObj = new URL(sourceURL);
    urlObj.protocol = "https:";
    urlObj.hostname = "www.icicilife.com";
    urlObj.port = ""; // Remove port
    return urlObj.toString();
  }

  return sourceURL;
};

export function loadLazyScript({
  id,
  type = "script",
  target = "head",
  src = "",
  async = false,
  defer = false,
  text = "",
  delay = 0,
  onLoadFn,
}) {
  return new Promise((resolve, reject) => {
    // Check if script already exists
    if (document.getElementById(id)) {
      if (typeof onLoadFn === "function") onLoadFn();
      return resolve();
    }

    const script = type === "link" ? document.createElement("link") : document.createElement("script");
    script.id = id;

    if (type === "link") {
      Object.assign(script, { href: src, rel: "stylesheet" });
    } else {
      if (src) script.src = src;
      if (text) script.textContent = text;
      script.async = async;
      script.defer = defer;
    }

    // Ensure correct target selection
    const targetNode = target === "head" ? document.head : document.body;
    if (!targetNode) {
      return reject(`Target node '${target}' not found.`);
    }

    // Delayed execution if needed
    setTimeout(() => {
      targetNode.appendChild(script);

      script.onload = () => {
        if (typeof onLoadFn === "function") onLoadFn();
        resolve();
      };

      script.onerror = () => {
        reject(`Failed to load script: ${id}`);
      };
    }, delay);
  });
}

export const AppFormFunctions = () => {
  return window.isAppFormLoaded ? true : false;
};
export const isAppointmentSchedulingEligible = () => {
  const productMetaName = getCurrentProductFromMeta();
  return ELIGIBLE_APPOINTMENT_SCHEDULING_PRODUCTS.includes(productMetaName);
};

// UTIL Function For HANDOVER
export const isOldJourney = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get("oldJourney") === OPTION_VALUES.TRUE_STRING;
};

// if PRODUCT is eligible for direct partner redirection
export const isProductEligibleForPartnerRedirection = () => {
  const currentProduct = getCurrentProductFromMeta();
  return PARTNER_DIRECT_REDIRECTION_ELIGIBLE_PRODUCTS?.includes(currentProduct);
};

export const hideHandOverLandingLoader = () => {
  try {
    document.querySelector(".Spinner_Background").style.display = "none";
    var spinner = document.querySelector("body").classList;
    if (spinner.contains("Spinner_Default")) spinner.remove("Spinner_Default");
  } catch (e) {
    console.log("Error hiding loader:", e);
  }
};
export const isCustomSavingPage = () => {
  const global = GlobalStore.getSnapshot();

  if (global?.isCustomSavingPage !== undefined) {
    return global.isCustomSavingPage;
  }
  const data = getQdataData();
  return data?.isCustomSavingPage === true;
};

export const isCustomPageLanding = () => {
  const query = readQueryParams();
  const csq = query.get("csq");
  return csq === "true";
};

export const getQdataData = () => {
  const query = readQueryParams();
  const qdata = query.get("qdata");
  if (qdata) {
    const { decryptAndMapBackToInput } = useQData();
    return decryptAndMapBackToInput(qdata);
  }
};
export const getPlanType = () => {
  const currentRider = QuoteFormStore.getSelectedRider();
  switch (currentRider) {
    case RIDER_TYPES.BTBB:
      return PLAN_TYPES.LIFE;

    case RIDER_TYPES.ADBY:
      return PLAN_TYPES.LIFE_PLUS;

    case RIDER_TYPES.WOP:
      return PLAN_TYPES.FOREVER;

    default:
      return PLAN_TYPES?.[getCurrentProductFromMeta()];
  }
};
export const isFundsRequired = () => {
  const productMetaName = getCurrentProductFromMeta();
  return FUNDS_REQUIRED_PRODUCTS.includes(productMetaName);
};

export const isCompanionDiscountApplicable = (companionDiscount, isPromotionalDiscountApplicable) => {
  const global = GlobalStore.getSnapshot();
  const {
    landingPage: { companion },
  } = global;
  const startDate = isPromotionalDiscountApplicable ? companion?.discountStartDate : companion?.companionStartDate;
  const endDate = isPromotionalDiscountApplicable ? companion?.discountEndDate : companion?.companionEndDate;

  if (companionDiscount > 0 && checkCompanionDiscountIsApplicable(startDate, endDate)) {
    return true;
  }
  return false;
};
export const getCampaignDiscountPercentagePrime = (paymentOption, promotional) => {
  if (paymentOption === OPTION_VALUES.RP || paymentOption === OPTION_VALUES.WLRP) {
    return promotional ? "2.5" : "5.0";
  } else if (paymentOption == OPTION_VALUES.SP) {
    return "1";
  }
  return "5";
};
export const getCampaignDiscountPercentage = (paymentOption) => {
  if (paymentOption === OPTION_VALUES.RP || paymentOption === OPTION_VALUES.WLRP) {
    return "2.5";
  } else if (paymentOption == OPTION_VALUES.SP) {
    return "1";
  }
  return "5";
};
export const getLocalStorage = (key) => {
  if (typeof window !== "undefined" && window.localStorage) {
    return window.localStorage.getItem(key);
  }
  return null;
};
export const redirectToURL = (data, redirectUrl = window.location.href, queryParam = "qdata", UID = 480) => {
  const { handleDataEncryption } = useQData();
  const encryptedQData = handleDataEncryption(data);

  const url = new URL(redirectUrl);
  const uid = url.searchParams.get("UID") || UID;

  url.search = "";
  url.searchParams.set("UID", uid);
  url.searchParams.set(queryParam, decodeURIComponent(encryptedQData));

  window.location.href = url.toString();
};

export const checkPersona = (persona) => {
  if (typeof window === "undefined" || typeof window.location === "undefined") return false;
  const queryParams = readQueryParams();
  const personaFromQuery = queryParams.get("persona");

  const pathSegments = window.location.pathname.split("/");
  const personaSegment = pathSegments.includes("persona") ? pathSegments[pathSegments.indexOf("persona") + 1] : null;

  const personaFromPath = personaSegment ? personaSegment.replace(".html", "") : null;

  const personaName = personaFromQuery || personaFromPath;

  return personaName?.toLowerCase() === persona.toLowerCase();
};

export const toNumber = (value, defaultValue = 0) => {
  if (value === undefined || value === null || value === "") {
    return defaultValue;
  }

  const num = typeof value === "number" ? value : Number(value);
  return Number.isNaN(num) ? defaultValue : num;
};

export const updateCurrentProductInMeta = (product) => {
  document?.querySelector('meta[property="current_product"]')?.setAttribute("content", product);
};

export const getCurrencySign = () => {
  const currentProduct = getCurrentProductFromMeta();
  const currencyMapper = {
    [PRODUCT_KEYS.GIFT_CITY]: DOLLAR_SIGN,
    [PRODUCT_KEYS.GLOBAL_WEALTH_ACCELERATOR]: DOLLAR_SIGN,
  };
  return currencyMapper[currentProduct] || CURRENCY_SIGN;
};
export const getExtra4Riders = (quoteData = {}) => {
  const {
    adb_selected,
    atpd_selected,
    ci_selected,
    wop_selected,
    ADB_SA,
    ATPD_SA,
    CI_SA,
    ciMode,
    wop_benefit,
    premiumSecondYear,
  } = quoteData;

  const parts = [];

  if (adb_selected) {
    parts.push(`${ADB_SA}${IPS_RIDER.ADB}`);
  }

  if (atpd_selected) {
    parts.push(`${ATPD_SA}${IPS_RIDER.ATPD}`);
  }

  if (ci_selected) {
    const ciCode = ciMode === OPTION_VALUES.CI_MODES.CLASSIC.years ? IPS_RIDER.CICL : IPS_RIDER.CICM;
    parts.push(`${CI_SA}${ciCode}`);
  }

  if (wop_selected) {
    const wopCode = wop_benefit === OPTION_VALUES.WOPList.CRITICAL_ILLNESS ? IPS_RIDER.WOPH : IPS_RIDER.WOPHC;
    parts.push(`${premiumSecondYear}${wopCode}`);
  }

  return parts.join("_");
};

export const getApiConstants = () => {
  const productKey = {
    [PRODUCT_KEYS.GIFT_CITY]: {
      source: API_CONSTANTS.sourceNew,
      sourceKey: API_CONSTANTS.sourceKeyNew,
    },
    [PRODUCT_KEYS.GLOBAL_WEALTH_ACCELERATOR]: {
      source: API_CONSTANTS.sourceNew,
      sourceKey: API_CONSTANTS.sourceKeyNew,
    },
    default: {
      source: API_CONSTANTS.source,
      sourceKey: API_CONSTANTS.sourceKey,
    },
  };

  return productKey[getCurrentProductFromMeta()] || productKey.default;
};
export const getActiveRiders = (quoteFormData) => {
  const riderMap = [
    { key: "ci_selected", label: "Critical Illness Cover" },
    { key: "adb_selected", label: "Accidental Death Cover" },
    { key: "atpd_selected", label: "Accidental Total & Permanent Disability" },
    { key: "wop_selected", label: "Waiver of Premium" },
  ];

  return riderMap
    .filter((rider) => quoteFormData?.[rider.key])
    .map((rider) => rider.label)
    .join(", ");
};

export const getFundInfo = (sortedData) => {
  const foundFund = sortedData.find((fund) => fund.LAfundCode === MONEY_MARKET_FUND);
  return {
    index: sortedData.findIndex((fund) => fund.LAfundCode === MONEY_MARKET_FUND),
    data: foundFund,
  };
};

export const singlePaymentFrequencyProduct = [PRODUCT_KEYS.GPP, PRODUCT_KEYS.SARAL_PENSION];

export const isSinglePaymentFrequencyProduct = () => {
  const currentProductMeta = getCurrentProductFromMeta();
  return singlePaymentFrequencyProduct?.includes(currentProductMeta);
};
export const isExistingCustomerChanged = ({ formFields, prevValuesRef, existingCustDetails }) => {
  let mobileno = formFields?.mobileno;
  let user_dob = formFields?.user_dob;
  const hasMobileChanged = prevValuesRef.current.mobileno !== formFields?.mobileno;
  const hasDobChanged = prevValuesRef.current.user_dob !== formFields?.user_dob;
  if (!existingCustDetails || hasMobileChanged || hasDobChanged) {
    prevValuesRef.current = { mobileno, user_dob };
    return true;
  }
  return false;
};

export const isWithinDateRange = (startDate, endDate, date = new Date()) => {
  if (!startDate || !endDate) return false;

  const start = new Date(startDate);
  start.setHours(0, 0, 0, 0);

  const end = new Date(endDate);
  end.setHours(23, 59, 59, 999);

  return date >= start && date <= end;
};

export const getNavFundReleasedCode = ({ fund = [] }) => {
  const latestFund = getLatestFundObject(fund);
  if (!latestFund) return "";

  const { startNavDate, endNavDate, LAfundCode } = latestFund;
  if (!startNavDate || !endNavDate) return "";

  return isWithinDateRange(startNavDate, endNavDate) ? LAfundCode : "";
};

export const convertddMMYYToddMmmYyyy = (dob) => {
  if (!dob) return "";

  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  const slashFormat = dob.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (slashFormat) {
    const [, day, month, year] = slashFormat;
    const monthIndex = Number(month) - 1;

    if (monthIndex >= 0 && monthIndex < 12) {
      return `${day}-${monthNames[monthIndex]}-${year}`;
    }
  }

  const hyphenFormat = dob.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (hyphenFormat) {
    const [, year, month, day] = hyphenFormat;
    const monthIndex = Number(month) - 1;

    if (monthIndex >= 0 && monthIndex < 12) {
      return `${day}-${monthNames[monthIndex]}-${year}`;
    }
  }

  const parsedDate = new Date(dob);
  if (!Number.isNaN(parsedDate.getTime())) {
    const day = String(parsedDate.getDate()).padStart(2, "0");
    const month = monthNames[parsedDate.getMonth()];
    const year = parsedDate.getFullYear();
    return `${day}-${month}-${year}`;
  }

  return dob;
};

export const createActivityDetector = ({
  idleMs = 5000,
  onIdle, // called when user goes idle
  onActive, // called when user becomes active again
  events = ["mousemove", "mousedown", "keydown", "scroll", "touchstart", "click"],
} = {}) => {
  let timer;
  let isIdle = false;

  const listenerOptions = { passive: true };

  function handleActivity() {
    if (isIdle) {
      isIdle = false;
      onActive?.();
    }

    clearTimeout(timer);

    timer = setTimeout(() => {
      isIdle = true;
      onIdle?.();
    }, idleMs);
  }

  events.forEach((event) => {
    document.addEventListener(event, handleActivity, listenerOptions);
  });

  handleActivity();

  return {
    destroy() {
      clearTimeout(timer);

      events.forEach((event) => {
        document.removeEventListener(event, handleActivity, listenerOptions);
      });
    },
  };
};

export const getIPSPlanType = (eligible, spouseCover, companionDiscount, backDateionApplied) => {
  return eligible
    ? `SmartExit:opted${spouseCover ? ` spouse:opted` : ""}${isCompanionDiscountApplicable(companionDiscount, false) ? " camp_disc" : ""}${backDateionApplied ? " RCD" : ""}`
    : `SmartExit:NotOpted${spouseCover ? ` spouse:opted` : ""}${isCompanionDiscountApplicable(companionDiscount, false) ? " camp_disc" : ""}${backDateionApplied ? " RCD" : ""}`;
};

export const getSuitabilityBasePath = (useLocalSuitability = false) => {
  if (typeof window === "undefined" || typeof window.location === "undefined") {
    return;
  }

  const { href, hostname } = window.location;
  const queryParams = new URL(href).searchParams;
  const isLocalHost = hostname === "localhost" || hostname === "127.0.0.1";
  const isILife = href.includes("ilife");

  const isTesting =
    href.includes("aempoc") || href.includes("/testing/") || (isLocalHost && queryParams.get("suitability") !== "prod");

  return useLocalSuitability
    ? "http://127.0.0.1:5505/"
    : `https://www.icicilife.com/content/icici-prudential-life-insurance/${
        isTesting ? (isILife ? "ilife/" : "testing/") : "ilife/"
      }ulip-plans/suitability_component_new/`;
};

export const getMultiplier = (frequency) => {
  const multiplier = {
    Monthly: 12,
    Quarterly: 4,
    "Half-Yearly": 2,
    Yearly: 1,
  };
  return multiplier[frequency] || 1;
};

export const resolveRedirectURL = ({ qdata }) => {
  let product = "aem-sites-react-spa-ssr";
  if (product === "aem-signatureassure" || product === "aem-signatureassureprod")
    return (
      "https://www.icicilife.com/ulip-plans/unit-linked-insurance-plans/buy-icici-pru-ulip-signature-assure.html?qdata=" +
      qdata
    );
  return null;
};

export const isGroupEmployee = (calcData) => {
  const currentProduct = getCurrentProductFromMeta();
  return GROUP_EMP_PRODUCTS.includes(currentProduct) && calcData.is_icici_employee;
};
export const getBackDationDate = (dob) => {
  const [day, month] = dob.split("/").map(Number);
  const currentYear = new Date().getFullYear();

  const date = new Date(currentYear, month - 1, day);
  date.setDate(date.getDate() - 1);

  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  const formattedDay = String(date.getDate()).padStart(2, "0");
  const formattedMonth = months[date.getMonth()];
  const formattedYear = date.getFullYear();

  return `${formattedDay}/${formattedMonth}/${formattedYear}`;
};
/**
 * Checks whether customer is eligible for back dating.
 *
 * @param {string} dob - Customer DOB in dd/mm/yyyy format
 * @param {number} maxDays - Maximum allowed days (e.g. 15)
 * @param {string} rateChangeDate - AEM Date format:
 *        "{Date}2026-05-27T00:00:00.000+05:30"
 *
 * @returns {boolean}
 */
export const isEligibleForBackDation = (dob, maxDays, rateChangeDate) => {
  if (getAge(dob) == 18) {
    return false;
  }
  if (!dob && !rateChangeDate) {
    return false;
  }

  const MILLISECONDS_IN_A_DAY = 1000 * 60 * 60 * 24;

  const parseDob = (date) => {
    const [day, month, year] = date.split("/").map(Number);
    return new Date(year, month - 1, day);
  };

  const parseRateChangeDate = (date) => {
    if (!date) return null;
    return new Date(date.replace("{Date}", ""));
  };

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  // Parse DOB
  const dobDate = parseDob(dob);

  // Birthday in current year
  let birthdayThisYear = new Date(today.getFullYear(), dobDate.getMonth(), dobDate.getDate());

  // If birthday hasn't occurred yet, use previous year's birthday
  if (birthdayThisYear > today) {
    birthdayThisYear.setFullYear(today.getFullYear() - 1);
  }

  // Financial year starts on 1 April
  const financialYearStart =
    today >= new Date(today.getFullYear(), 3, 1)
      ? new Date(today.getFullYear(), 3, 1)
      : new Date(today.getFullYear() - 1, 3, 1);

  const parsedRateChangeDate = parseRateChangeDate(rateChangeDate);

  // Effective start date = later of FY start and rate change date
  const effectiveStartDate =
    parsedRateChangeDate && parsedRateChangeDate > financialYearStart ? parsedRateChangeDate : financialYearStart;

  const diffInDays = Math.floor((today - birthdayThisYear) / MILLISECONDS_IN_A_DAY);

  return diffInDays >= 0 && diffInDays < maxDays && birthdayThisYear >= effectiveStartDate;
};

export const getOfferValidTillDate = (dobStr) => {
  if (!dobStr) return "";
  const [day, month] = dobStr.split("/").map(Number);
  const currentYear = new Date().getFullYear();
  const date = new Date(currentYear, month - 1, day);
  date.setDate(date.getDate() + 15);
  return date.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
};

export const maskValue = (str = "", mask = OPTION_VALUES.MASK.MOBILE) => {
  if (mask == OPTION_VALUES.MASK.MOBILE) {
    if (str.length <= 6) {
      return "X".repeat(str.length);
    }

    const masked = "X".repeat(6);
    const visible = String(str)?.slice(6); // show after 6th char
    return masked + visible;
  }

  if (mask == OPTION_VALUES.MASK.ACCOUNT_NUMBER) {
    return str.replace(/.(?=.{4})/g, "X");
  }

  if (!str) {
    return "";
  }

  const [mail, domain] = str.split("@");
  const visible = mail.slice(-2);
  const masked = "X".repeat(Math.max(0, mail.length - 2));
  return masked + visible + "@" + domain;
};

export const getqdata = () => {
  const { calculatorFormData } = GlobalStore.getSnapshot();
  const qData = getNetCorePageInputs(calculatorFormData);
  const { encryptBlowfish } = useBlowFish({
    key: APP_KEY_BLOWFISH2,
  });
  return encryptBlowfish(JSON.stringify(qData));
};

export const isCurrentlyOutsideIndia = (calculatorFormData) => {
  return !!calculatorFormData?.isOutsideIndia;
};

export const normalizeProductName = (name = "") => {
  //It will replace all of ICICI Prudential Life,  ICICI Prudential , ICICI Pru Life, ICICI Prulife, ICICI Pru to
  //ICICI Life
  return name.replace(/\bICICI\s+(?:Prudential\s+Life|Prudential|Pru\s+Life|Prulife|Pru)\b/gi, "ICICI Life");
};
